import { SvgIcon } from "@mui/material";

// duotone svgs

export const FilterDuotoneIcon = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="#046172ff" xmlns="http://www.w3.org/2000/svg">
		<g id="style=doutone">
			<g id="filter-rectangle">
				<path id="vector (Stroke)" fillRule="evenodd" clipRule="evenodd" d="M7.75 17.5C7.75 17.0858 7.41421 16.75 7 16.75H2C1.58579 16.75 1.25 17.0858 1.25 17.5C1.25 17.9142 1.58579 18.25 2 18.25H7C7.41421 18.25 7.75 17.9142 7.75 17.5Z" fill="#046172ff" />
				<path id="vector (Stroke)_2" fillRule="evenodd" clipRule="evenodd" d="M16.25 6.5C16.25 6.08579 16.5858 5.75 17 5.75H22C22.4142 5.75 22.75 6.08579 22.75 6.5C22.75 6.91421 22.4142 7.25 22 7.25H17C16.5858 7.25 16.25 6.91421 16.25 6.5Z" fill="#046172ff" />
				<path id="vector (Stroke)_3" fillRule="evenodd" clipRule="evenodd" d="M22.75 17.5C22.75 17.0858 22.4142 16.75 22 16.75H13C12.5858 16.75 12.25 17.0858 12.25 17.5C12.25 17.9142 12.5858 18.25 13 18.25H22C22.4142 18.25 22.75 17.9142 22.75 17.5Z" fill="#046172ff" />
				<path id="vector (Stroke)_4" fillRule="evenodd" clipRule="evenodd" d="M1.25 6.5C1.25 6.08579 1.58579 5.75 2 5.75H11C11.4142 5.75 11.75 6.08579 11.75 6.5C11.75 6.91421 11.4142 7.25 11 7.25H2C1.58579 7.25 1.25 6.91421 1.25 6.5Z" fill="#046172ff" />
				<path id="rec (Stroke)" fillRule="evenodd" clipRule="evenodd" d="M6.25 15.5C6.25 14.5335 7.0335 13.75 8 13.75H12C12.9665 13.75 13.75 14.5335 13.75 15.5V19.5C13.75 20.4665 12.9665 21.25 12 21.25H8C7.0335 21.25 6.25 20.4665 6.25 19.5V15.5ZM8 15.25C7.86193 15.25 7.75 15.3619 7.75 15.5V19.5C7.75 19.6381 7.86193 19.75 8 19.75H12C12.1381 19.75 12.25 19.6381 12.25 19.5V15.5C12.25 15.3619 12.1381 15.25 12 15.25H8Z" fill="#046172ff" />
				<path id="rec (Stroke)_2" fillRule="evenodd" clipRule="evenodd" d="M17.75 4.5C17.75 3.5335 16.9665 2.75 16 2.75H12C11.0335 2.75 10.25 3.5335 10.25 4.5V8.5C10.25 9.4665 11.0335 10.25 12 10.25H16C16.9665 10.25 17.75 9.4665 17.75 8.5V4.5ZM16 4.25C16.1381 4.25 16.25 4.36193 16.25 4.5V8.5C16.25 8.63807 16.1381 8.75 16 8.75H12C11.8619 8.75 11.75 8.63807 11.75 8.5V4.5C11.75 4.36193 11.8619 4.25 12 4.25H16Z" fill="#046172ff" />
			</g>
		</g>
	</svg>
);

export const MergeOrderDuotoneIcon = ({ width = 24, height = 24 }) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 1024 1024"
		className="icon"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg">
		<path d="M902.3 517.4l-3.2 4.9c-0.6 1-63.7 96.2-145 209.5-62.8 87.5-135.9 99.1-170.5 99.1-11.6 0-18.9-1.3-20.1-1.5H356l-14.5-14.3h223.4c5.4 0.9 99.1 17.3 177.5-91.7 70.5-98.1 127-182.5 141.2-203.8-10.2-8.3-43-35.2-74.6-30.1-10.2 1.7-25.6 13.2-42.5 29.9l-2.3-2.3v-16.9c16.2-13.8 31.3-23.1 42.6-24.9 47.3-7.7 89.6 36.4 91.2 38l4.3 4.1z" fill="#666" />
		<path d="M883.6 519.6c-14.2 21.4-70.7 105.8-141.2 203.8-78.4 109-172.1 92.6-177.5 91.7H341.5L186.8 661.9C200.6 638.4 274 530.7 440 582c7.5 6.3 44.5 31.2 130.8 11.3 11.6-2.7 21.7-3.8 30.6-3.8 26.7 0 41.6 10.5 49.6 20.8 13.7 17.4 13.7 41.3 6.8 55.1-14.1 28.1-37.5 40.6-75.8 40.6H454.5v14.3H582c44 0 72.1-15.5 88.7-48.6 3.2-6.5 5.2-14.8 5.6-23.7l0.1 0.3c13.4-36.6 55-94 90.2-128.9 16.9-16.8 32.2-28.3 42.5-29.9 31.5-5.1 64.3 21.7 74.5 30.1z" fill="#bdbabd5e" />
		<path d="M796.5 265.2v75.6c0 16.4-13.3 29.7-29.7 29.7h-2.6v129.8c-4.5 4-9.1 8.2-13.8 12.7V370.5H605.1v204.9c-5-0.3-10.4-0.1-16.1 0.5V252.5c-1.4 0-2.6 0.1-4 0.1-11 0-22.6-0.4-34.9-1H546.6c-4.9 0.3-9.5 0.4-14.1 0.6v332.9c-5.8 0.6-11.1 1-16.1 1.2V370.5H367v183.9c-4.7-0.4-9.3-0.4-13.8-0.4V370.5h-6.5c-16.4 0-29.8-13.3-29.8-29.7v-75.6c0-16.4 13.4-29.7 29.8-29.7h66.5c-11.5-6.1-20.1-13.6-25.3-22.8-15.9-28.1 4.7-58.8 5.6-60.1 14.8-18 31.5-25.8 50-23.7 47.1 5.2 90.5 75.8 104.9 101.5 14.5-25.7 57.9-96.3 105-101.5 18.4-2.2 35.2 5.6 49.6 23 1.3 1.9 21.9 32.6 6 60.7-5.2 9.2-13.8 16.6-25.3 22.8h83.2c16.3 0.1 29.6 13.4 29.6 29.8z m-16.1 75.6v-75.6c0-7.5-6.1-13.6-13.6-13.6H614.3c-3.1 0.1-6 0.4-9.2 0.5v102.2h161.8c7.4 0 13.5-6 13.5-13.5zM694.9 205c11-19.4-4.7-43-4.9-43.2-10.5-12.5-22.1-18.3-34.9-16.8-34.8 3.8-73 58.8-91 90.5H616c51.2-3.9 71.6-17.7 78.9-30.5z m-214.5 30.5h52.2c-18-31.7-56.1-86.7-90.9-90.5-12.9-1.4-24.6 4.2-35.4 17.4 0.1 0-15.2 23.3-4.3 42.6 7.2 12.6 27.3 26.6 78.4 30.5z m36.1 118.8V252.7h-4.7c-10.5 0-20.1-0.4-29.3-1H346.7c-7.5 0-13.6 6-13.6 13.6v75.6c0 7.5 6 13.6 13.6 13.6h169.8z" fill="#666" /><path d="M780.4 265.2v75.6c0 7.5-6.1 13.6-13.6 13.6H605.1V252.2c3.2-0.1 6.1-0.4 9.2-0.5h152.6c7.4 0 13.5 6 13.5 13.5z" fill="#bdbabd5e" />
		<path d="M764.3 517.1l2.3 2.3c-35.2 34.9-76.7 92.3-90.2 128.9l-0.1-0.3c0.6-8.6-0.4-17.9-3.5-26.9 15.1-36.2 46.8-78.5 77.6-108.3v10.9l8.4-6.6h5.5z" fill="#666" />
		<path d="M764.3 500.2v16.9h-5.4l-8.4 6.6v-10.9c4.7-4.4 9.3-8.6 13.8-12.6z" fill="#666" />
		<path d="M750.5 370.5V513c-30.8 29.8-62.5 72.1-77.6 108.3-2.3-6.9-5.8-13.7-10.6-19.8-8.2-10.4-25.2-24.9-57.2-26.1V370.5h145.4z" fill="#bdbabd5e" />
		<path d="M690 161.8c0.1 0.3 15.9 23.8 4.9 43.2-7.3 12.8-27.6 26.6-78.9 30.6h-52c18-31.7 56.3-86.7 91-90.5 12.9-1.6 24.5 4.1 35 16.7z" fill="#bdbabd5e" />
		<path d="M672.9 621.2c3.1 9 4.1 18.3 3.5 26.9l-6.1-20.1c0.7-2.2 1.5-4.5 2.6-6.8z" fill="#666" />
		<path d="M670.2 628l6.1 20.1c-0.4 8.8-2.4 17.1-5.6 23.7-16.6 33.1-44.8 48.6-88.7 48.6H454.5V706H582c38.4 0 61.8-12.5 75.8-40.7 6.9-13.8 6.9-37.7-6.8-55.1-8.1-10.4-22.9-20.8-49.6-20.8v-4h3.7v-10.1c32 1.2 49 15.7 57.2 26.1 4.9 6.1 8.3 12.9 10.6 19.8-1.1 2.3-1.9 4.6-2.7 6.8z" fill="#666" />
		<path d="M605.1 575.3v10.1h-3.7l-12.4 0.3v-9.8c5.7-0.7 11.1-0.8 16.1-0.6z" fill="#666" />
		<path d="M601.4 585.4v4c-8.8 0-18.9 1.2-30.6 3.8-86.3 19.9-123.3-5-130.8-11.3-166-51.3-239.4 56.4-253.2 79.9l-10.4-10.4c15.5-24.9 69.4-96.5 176.7-97.6v6.1H367v-5.8c23.7 0.9 49.9 5.5 78.6 14.5l1.7 0.5 1.3 1.2c0.3 0.3 19.1 17.4 67.9 15.9v5h5l11.1-0.1v-6c10.5-1 22.1-2.9 35-5.9 7.7-1.7 14.8-2.8 21.4-3.5v9.8l12.4-0.1z" fill="#666" />
		<path d="M589 252.5v323.3c-6.5 0.6-13.7 1.8-21.4 3.5-12.9 2.9-24.6 4.9-35 5.9V252.3c4.6-0.3 9.2-0.4 14.1-0.6H550.2c12.3 0.6 23.9 1 34.9 1 1.3 0 2.5-0.2 3.9-0.2z" fill="#bdbabd5e" />
		<path d="M532.6 585.2v6l-11.1 0.1h-5v-5c5-0.1 10.3-0.5 16.1-1.1z" fill="#666" />
		<path d="M532.6 235.5h-52.2c-51.2-4-71.2-17.9-78.5-30.6-10.9-19.3 4.5-42.6 4.3-42.6 10.9-13.2 22.5-18.8 35.4-17.4 34.9 3.9 73 58.9 91 90.6z" fill="#bdbabd5e" />
		<path d="M516.5 370.5v215.9c-48.8 1.5-67.6-15.6-67.9-15.9l-1.3-1.2-1.7-0.5c-28.8-9-55-13.6-78.6-14.5V370.5h149.5z" fill="#bdbabd5e" />
		<path d="M516.5 252.7v101.7H346.7c-7.5 0-13.6-6-13.6-13.6v-75.6c0-7.5 6-13.6 13.6-13.6h135.8c9.2 0.6 18.8 1 29.3 1 1.5 0.1 3.1 0.1 4.7 0.1z" fill="#bdbabd5e" />
		<path d="M367 554.3v5.8h-13.8V554c4.5 0 9.1 0 13.8 0.3zM360.6 834c19.2 19.1 19.4 50.3 0.3 69.4l-21.6 21.9c-9.2 9.3-21.5 14.5-34.7 14.5h-0.3c-13 0-25.3-5-34.5-14.1L72.5 730.3C63.3 721 58 708.7 58 695.5s5-25.4 14.2-34.8l21.6-21.9c9.2-9.2 21.5-14.5 34.7-14.5h0.3c13 0 25.3 5 34.7 14.2l13 12.9c-3.2 5.1-4.7 8.3-4.9 8.6l12.8 6.1c0.1-0.1 0.9-1.7 2.4-4.3L341.5 815H334v12.7l-180.7-179c-6.5-6.4-15.2-10-24.6-10h-0.1c-9.3 0-18.2 3.7-24.7 10.2l-21.6 21.9c-6.5 6.5-10 15.3-10 24.7 0 9.3 3.7 18 10.2 24.6l197.3 195.4c6.5 6.5 15.2 10.1 24.4 10.1h0.3c9.3-0.1 18-3.7 24.6-10.4l21.6-21.7c13.6-13.7 13.4-35.8-0.3-49.4l-14.8-14.7H356l4.6 4.6z" fill="#666" />
		<path d="M356 829.4h-20.3l-1.7-1.7v-12.6h7.5z" fill="#666" />
		<path d="M350.5 844.1c13.7 13.6 13.8 35.7 0.3 49.4l-21.6 21.7c-6.5 6.6-15.2 10.2-24.6 10.4h-0.3c-9.2 0-17.9-3.6-24.4-10.1L82.6 720.1c-6.5-6.5-10.2-15.2-10.2-24.6 0-9.3 3.5-18.2 10-24.7l21.6-21.9c6.5-6.5 15.3-10.2 24.7-10.2h0.1c9.3 0 18 3.6 24.6 10l180.7 179v1.7h1.7l14.7 14.7z" fill="#bdbabd5e" />
		<path d="M335.7 829.4H334v-1.7zM176.4 651.5l10.4 10.4c-1.5 2.7-2.3 4.2-2.4 4.3l-12.8-6.1c0.1-0.3 1.7-3.5 4.8-8.6z" fill="#666" />
	</svg>
);

export const MergePublishOrderDuotoneIcon = ({ width = 24, height = 24 }) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 1024 1024"
		className="icon"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg">
		<path d="M902.3 517.4l-3.2 4.9c-0.6 1-63.7 96.2-145 209.5-62.8 87.5-135.9 99.1-170.5 99.1-11.6 0-18.9-1.3-20.1-1.5H356l-14.5-14.3h223.4c5.4 0.9 99.1 17.3 177.5-91.7 70.5-98.1 127-182.5 141.2-203.8-10.2-8.3-43-35.2-74.6-30.1-10.2 1.7-25.6 13.2-42.5 29.9l-2.3-2.3v-16.9c16.2-13.8 31.3-23.1 42.6-24.9 47.3-7.7 89.6 36.4 91.2 38l4.3 4.1z" fill="#666" />
		<path d="M883.6 519.6c-14.2 21.4-70.7 105.8-141.2 203.8-78.4 109-172.1 92.6-177.5 91.7H341.5L186.8 661.9C200.6 638.4 274 530.7 440 582c7.5 6.3 44.5 31.2 130.8 11.3 11.6-2.7 21.7-3.8 30.6-3.8 26.7 0 41.6 10.5 49.6 20.8 13.7 17.4 13.7 41.3 6.8 55.1-14.1 28.1-37.5 40.6-75.8 40.6H454.5v14.3H582c44 0 72.1-15.5 88.7-48.6 3.2-6.5 5.2-14.8 5.6-23.7l0.1 0.3c13.4-36.6 55-94 90.2-128.9 16.9-16.8 32.2-28.3 42.5-29.9 31.5-5.1 64.3 21.7 74.5 30.1z" fill="#bdbabd5e" />
		<path d="M796.5 265.2v75.6c0 16.4-13.3 29.7-29.7 29.7h-2.6v129.8c-4.5 4-9.1 8.2-13.8 12.7V370.5H605.1v204.9c-5-0.3-10.4-0.1-16.1 0.5V252.5c-1.4 0-2.6 0.1-4 0.1-11 0-22.6-0.4-34.9-1H546.6c-4.9 0.3-9.5 0.4-14.1 0.6v332.9c-5.8 0.6-11.1 1-16.1 1.2V370.5H367v183.9c-4.7-0.4-9.3-0.4-13.8-0.4V370.5h-6.5c-16.4 0-29.8-13.3-29.8-29.7v-75.6c0-16.4 13.4-29.7 29.8-29.7h66.5c-11.5-6.1-20.1-13.6-25.3-22.8-15.9-28.1 4.7-58.8 5.6-60.1 14.8-18 31.5-25.8 50-23.7 47.1 5.2 90.5 75.8 104.9 101.5 14.5-25.7 57.9-96.3 105-101.5 18.4-2.2 35.2 5.6 49.6 23 1.3 1.9 21.9 32.6 6 60.7-5.2 9.2-13.8 16.6-25.3 22.8h83.2c16.3 0.1 29.6 13.4 29.6 29.8z m-16.1 75.6v-75.6c0-7.5-6.1-13.6-13.6-13.6H614.3c-3.1 0.1-6 0.4-9.2 0.5v102.2h161.8c7.4 0 13.5-6 13.5-13.5zM694.9 205c11-19.4-4.7-43-4.9-43.2-10.5-12.5-22.1-18.3-34.9-16.8-34.8 3.8-73 58.8-91 90.5H616c51.2-3.9 71.6-17.7 78.9-30.5z m-214.5 30.5h52.2c-18-31.7-56.1-86.7-90.9-90.5-12.9-1.4-24.6 4.2-35.4 17.4 0.1 0-15.2 23.3-4.3 42.6 7.2 12.6 27.3 26.6 78.4 30.5z m36.1 118.8V252.7h-4.7c-10.5 0-20.1-0.4-29.3-1H346.7c-7.5 0-13.6 6-13.6 13.6v75.6c0 7.5 6 13.6 13.6 13.6h169.8z" fill="lightgray" /><path d="M780.4 265.2v75.6c0 7.5-6.1 13.6-13.6 13.6H605.1V252.2c3.2-0.1 6.1-0.4 9.2-0.5h152.6c7.4 0 13.5 6 13.5 13.5z" fill="#bdbabd5e" />
		<path d="M764.3 517.1l2.3 2.3c-35.2 34.9-76.7 92.3-90.2 128.9l-0.1-0.3c0.6-8.6-0.4-17.9-3.5-26.9 15.1-36.2 46.8-78.5 77.6-108.3v10.9l8.4-6.6h5.5z" fill="#666" />
		<path d="M764.3 500.2v16.9h-5.4l-8.4 6.6v-10.9c4.7-4.4 9.3-8.6 13.8-12.6z" fill="#666" />
		<path d="M750.5 370.5V513c-30.8 29.8-62.5 72.1-77.6 108.3-2.3-6.9-5.8-13.7-10.6-19.8-8.2-10.4-25.2-24.9-57.2-26.1V370.5h145.4z" fill="#bdbabd5e" />
		<path d="M690 161.8c0.1 0.3 15.9 23.8 4.9 43.2-7.3 12.8-27.6 26.6-78.9 30.6h-52c18-31.7 56.3-86.7 91-90.5 12.9-1.6 24.5 4.1 35 16.7z" fill="#bdbabd5e" />
		<path d="M672.9 621.2c3.1 9 4.1 18.3 3.5 26.9l-6.1-20.1c0.7-2.2 1.5-4.5 2.6-6.8z" fill="#666" />
		<path d="M670.2 628l6.1 20.1c-0.4 8.8-2.4 17.1-5.6 23.7-16.6 33.1-44.8 48.6-88.7 48.6H454.5V706H582c38.4 0 61.8-12.5 75.8-40.7 6.9-13.8 6.9-37.7-6.8-55.1-8.1-10.4-22.9-20.8-49.6-20.8v-4h3.7v-10.1c32 1.2 49 15.7 57.2 26.1 4.9 6.1 8.3 12.9 10.6 19.8-1.1 2.3-1.9 4.6-2.7 6.8z" fill="#666" />
		<path d="M605.1 575.3v10.1h-3.7l-12.4 0.3v-9.8c5.7-0.7 11.1-0.8 16.1-0.6z" fill="#666" />
		<path d="M601.4 585.4v4c-8.8 0-18.9 1.2-30.6 3.8-86.3 19.9-123.3-5-130.8-11.3-166-51.3-239.4 56.4-253.2 79.9l-10.4-10.4c15.5-24.9 69.4-96.5 176.7-97.6v6.1H367v-5.8c23.7 0.9 49.9 5.5 78.6 14.5l1.7 0.5 1.3 1.2c0.3 0.3 19.1 17.4 67.9 15.9v5h5l11.1-0.1v-6c10.5-1 22.1-2.9 35-5.9 7.7-1.7 14.8-2.8 21.4-3.5v9.8l12.4-0.1z" fill="#666" />
		<path d="M589 252.5v323.3c-6.5 0.6-13.7 1.8-21.4 3.5-12.9 2.9-24.6 4.9-35 5.9V252.3c4.6-0.3 9.2-0.4 14.1-0.6H550.2c12.3 0.6 23.9 1 34.9 1 1.3 0 2.5-0.2 3.9-0.2z" fill="#bdbabd5e" />
		<path d="M532.6 585.2v6l-11.1 0.1h-5v-5c5-0.1 10.3-0.5 16.1-1.1z" fill="#666" />
		<path d="M532.6 235.5h-52.2c-51.2-4-71.2-17.9-78.5-30.6-10.9-19.3 4.5-42.6 4.3-42.6 10.9-13.2 22.5-18.8 35.4-17.4 34.9 3.9 73 58.9 91 90.6z" fill="#bdbabd5e" />
		<path d="M516.5 370.5v215.9c-48.8 1.5-67.6-15.6-67.9-15.9l-1.3-1.2-1.7-0.5c-28.8-9-55-13.6-78.6-14.5V370.5h149.5z" fill="#bdbabd5e" />
		<path d="M516.5 252.7v101.7H346.7c-7.5 0-13.6-6-13.6-13.6v-75.6c0-7.5 6-13.6 13.6-13.6h135.8c9.2 0.6 18.8 1 29.3 1 1.5 0.1 3.1 0.1 4.7 0.1z" fill="#bdbabd5e" />
		<path d="M367 554.3v5.8h-13.8V554c4.5 0 9.1 0 13.8 0.3zM360.6 834c19.2 19.1 19.4 50.3 0.3 69.4l-21.6 21.9c-9.2 9.3-21.5 14.5-34.7 14.5h-0.3c-13 0-25.3-5-34.5-14.1L72.5 730.3C63.3 721 58 708.7 58 695.5s5-25.4 14.2-34.8l21.6-21.9c9.2-9.2 21.5-14.5 34.7-14.5h0.3c13 0 25.3 5 34.7 14.2l13 12.9c-3.2 5.1-4.7 8.3-4.9 8.6l12.8 6.1c0.1-0.1 0.9-1.7 2.4-4.3L341.5 815H334v12.7l-180.7-179c-6.5-6.4-15.2-10-24.6-10h-0.1c-9.3 0-18.2 3.7-24.7 10.2l-21.6 21.9c-6.5 6.5-10 15.3-10 24.7 0 9.3 3.7 18 10.2 24.6l197.3 195.4c6.5 6.5 15.2 10.1 24.4 10.1h0.3c9.3-0.1 18-3.7 24.6-10.4l21.6-21.7c13.6-13.7 13.4-35.8-0.3-49.4l-14.8-14.7H356l4.6 4.6z" fill="#666" />
		<path d="M356 829.4h-20.3l-1.7-1.7v-12.6h7.5z" fill="#666" />
		<path d="M350.5 844.1c13.7 13.6 13.8 35.7 0.3 49.4l-21.6 21.7c-6.5 6.6-15.2 10.2-24.6 10.4h-0.3c-9.2 0-17.9-3.6-24.4-10.1L82.6 720.1c-6.5-6.5-10.2-15.2-10.2-24.6 0-9.3 3.5-18.2 10-24.7l21.6-21.9c6.5-6.5 15.3-10.2 24.7-10.2h0.1c9.3 0 18 3.6 24.6 10l180.7 179v1.7h1.7l14.7 14.7z" fill="#bdbabd5e" />
		<path d="M335.7 829.4H334v-1.7zM176.4 651.5l10.4 10.4c-1.5 2.7-2.3 4.2-2.4 4.3l-12.8-6.1c0.1-0.3 1.7-3.5 4.8-8.6z" fill="#666" />

		<g transform="translate(305,40) scale(1)">
			<path
				d="M128 256 L256 128 L384 256"
				stroke="#666"
				strokeWidth="55"
				fill="none"
				strokeLinecap="round"
				strokeLinejoin="round" />
			<line
				x1="256" y1="128"
				x2="256" y2="440"
				stroke="#666"
				strokeWidth="55"
				strokeLinecap="round" />
			<line
				x1="128" y1="440"
				x2="384" y2="440"
				stroke="#666"
				strokeWidth="55"
				strokeLinecap="round" />
		</g>
	</svg>
);

export const AssignOrdersDuotoneIcon = ({ width = 21, height = 21 }) => (
	<svg
		version="1.1"
		id="Layer_1"
		xmlns="http://www.w3.org/2000/svg"
		width={width}
		height={height}
		x="0px"
		y="0px"
		viewBox="0 0 390.395 390.395"
		style={{ enableBackground: 'new 0 0 390.395 390.395' }}
	>
		<g>
			<polygon
				style={{ fill: '#bdbabd5e' }}
				points="198.917,241.322 339.265,214.171 255.289,157.864"
			/>
			<polygon
				style={{ fill: '#bdbabd5e' }}
				points="322.457,58.114 267.701,139.375 349.026,194.131"
			/>
			<polygon
				style={{ fill: '#bdbabd5e' }}
				points="306.23,43.504 165.818,71.108 249.859,127.48"
			/>
			<polygon
				style={{ fill: '#bdbabd5e' }}
				points="182.626,226.648 237.382,145.387 156.057,90.632"
			/>
		</g>
		<path
			style={{ fill: '#bdbabd5e' }}
			d="M108.412,286.252c-22.756,0-41.18,18.424-41.18,41.18s18.424,41.18,41.18,41.18
		s41.18-18.424,41.18-41.18S131.168,286.252,108.412,286.252z"
		/>
		<g>
			<path
				style={{ fill: '#666' }}
				d="M162.586,237.508c3.232,17.325,19.523,28.703,37.947,25.471l144.679-28.186
		  c18.941-3.232,29.285-20.04,25.471-37.947l-28.186-149.01c-4.331-18.941-21.139-29.285-37.947-25.471L159.289,50.034
		  c-17.907,2.715-29.802,22.756-25.471,37.947L162.586,237.508z M306.23,43.504l-56.372,83.976l-84.04-56.372L306.23,43.504z
		  M198.917,241.322l56.372-83.976l83.976,56.889L198.917,241.322z M267.701,139.375l54.756-81.261l26.57,136.016L267.701,139.375z
		  M237.382,145.387l-54.756,81.325l-26.57-136.016L237.382,145.387z"
			/>
			<path
				style={{ fill: '#666' }}
				d="M390.206,273.258c-1.099-5.947-7.046-9.762-12.477-8.663l-210.295,40.081
		  c-9.244-23.273-32-40.081-58.505-40.081h-0.517L64,9.306c-1.099-5.43-5.43-9.244-10.861-9.244H10.861C4.913,0.062,0,4.91,0,10.922
		  s4.848,10.861,10.861,10.861h33.616l42.279,246.626c-23.855,8.663-41.18,32-41.18,59.087c0,34.715,28.186,62.836,62.836,62.836
		  s62.836-28.186,62.836-62.836c0-0.517,0-1.099,0-1.099l210.295-40.081C387.491,285.217,391.305,279.205,390.206,273.258z
		  M108.412,368.676c-22.756,0-41.18-18.424-41.18-41.18c0-22.756,18.424-41.18,41.18-41.18s41.18,18.424,41.18,41.18
		  C149.592,350.252,131.168,368.676,108.412,368.676z"
			/>
		</g>
	</svg>
);

export const UnassignOrderDuotoneIcon = ({ width = 24, height = 24, fill = "#666" }) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 64 64"
		fill={fill} xmlns="http://www.w3.org/2000/svg">
		<path d="M16 24 C16 19, 22 14, 28 14 H36 C42 14, 48 19, 48 24 V50 C48 52, 46 54, 44 54 H20 C18 54, 16 52, 16 50 V24 Z"
			fill="#bdbabd5e" stroke="#666666" strokeWidth="2" />
		<line x1="24" y1="14" x2="24" y2="10" stroke="#666666" strokeWidth="2" />
		<line x1="40" y1="14" x2="40" y2="10" stroke="#666666" strokeWidth="2" />
		<circle cx="24" cy="10" r="2" fill="#666666" />
		<circle cx="40" cy="10" r="2" fill="#666666" />
		<circle cx="32" cy="36" r="10" fill="none" stroke={fill} strokeWidth="2" />
		<line x1="27" y1="31" x2="37" y2="41" stroke={fill} strokeWidth="3" />
		<line x1="37" y1="31" x2="27" y2="41" stroke={fill} strokeWidth="3" />
	</svg>
);

export const ShowRouteDuotoneIcon = ({ width = 21, height = 21, fill = "#666" }) => (
	<svg
		fill={fill}
		width={width}
		height={height}
		xmlns="http://www.w3.org/2000/svg"
		x="0px" y="0px"
		viewBox="0 0 512 512"
		style={{ enableBackground: 'new 0 0 512 512' }}
	>
		<g>
			<g>
				<g>
					<path fill="#666" d="M34.247,185.385c7.166,14.354,14.824,28.68,22.481,42.331c2.681,4.779,5.173,9.137,7.414,12.992
				c1.357,2.334,2.339,3.997,2.882,4.906c8.256,13.81,28.246,13.858,36.569,0.087c0.545-0.903,1.529-2.552,2.889-4.868
				c2.244-3.822,4.738-8.144,7.422-12.888c7.664-13.548,15.328-27.79,22.501-42.094c4.526-9.024,8.716-17.801,12.505-26.249
				c13.899-30.994,21.759-55.711,21.759-74.269C170.667,38.202,132.465,0,85.333,0S0,38.202,0,85.333
				c0,18.429,8.057,43.366,22.31,74.989C25.949,168.394,29.947,176.772,34.247,185.385z M85.333,42.667
				c23.567,0,42.667,19.099,42.667,42.667c0,10.682-6.49,31.091-18.024,56.811c-3.522,7.855-7.45,16.082-11.712,24.58
				c-4.135,8.246-8.458,16.499-12.853,24.607c-4.443-8.248-8.812-16.635-12.99-25.005c-4.059-8.131-7.817-16.006-11.212-23.537
				C49.37,116.523,42.667,95.778,42.667,85.333C42.667,61.766,61.766,42.667,85.333,42.667z"/>
					<path fill="#666" d="M426.667,256c-47.131,0-85.333,38.202-85.333,85.333c0,18.429,8.057,43.366,22.31,74.989
				c3.638,8.072,7.636,16.45,11.936,25.063c7.167,14.354,14.824,28.68,22.481,42.331c2.681,4.779,5.173,9.137,7.414,12.992
				c1.357,2.334,2.339,3.997,2.882,4.906c8.256,13.81,28.246,13.858,36.569,0.087c0.545-0.903,1.529-2.552,2.889-4.868
				c2.244-3.822,4.738-8.145,7.422-12.888c7.664-13.548,15.328-27.79,22.501-42.094c4.526-9.024,8.716-17.801,12.505-26.249
				C504.14,384.608,512,359.891,512,341.333C512,294.202,473.798,256,426.667,256z M451.309,398.144
				c-3.522,7.855-7.45,16.082-11.712,24.58c-4.135,8.246-8.458,16.499-12.853,24.607c-4.443-8.247-8.812-16.635-12.99-25.005
				c-4.059-8.131-7.817-16.006-11.212-23.537C390.703,372.523,384,351.778,384,341.333c0-23.567,19.099-42.667,42.667-42.667
				s42.667,19.099,42.667,42.667C469.333,352.016,462.843,372.424,451.309,398.144z"/>
					<path fill={fill} d="M85.333,341.333H160c29.446,0,53.333-23.887,53.333-53.333c0-5.882,4.785-10.667,10.667-10.667h74.667
				c35.249,0,64-28.751,64-64c0-35.249-28.751-64-64-64h-85.333c-11.782,0-21.333,9.551-21.333,21.333
				c0,11.782,9.551,21.333,21.333,21.333h85.333c11.685,0,21.333,9.649,21.333,21.333c0,11.685-9.649,21.333-21.333,21.333H224
				c-29.446,0-53.333,23.887-53.333,53.333c0,5.882-4.785,10.667-10.667,10.667H85.333c-35.249,0-64,28.751-64,64
				c0,35.249,28.751,64,64,64h192c11.782,0,21.333-9.551,21.333-21.333c0-11.782-9.551-21.333-21.333-21.333h-192
				C73.649,384,64,374.351,64,362.667S73.649,341.333,85.333,341.333z"/>
				</g>
			</g>
		</g>
	</svg>
);

export const AreaCoverageDuotoneIcon = ({ width = 24, height = 24, fill = "#666" }) => (
	<svg
		width={width}
		height={height} viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg">
		<path fill="#666" d="M21.8 15.66c0 3.479-1.17 6.14-4.553 6.14-3.743 0-5.414-2.337-8.7-2.337-.844 0-1.535.154-2.22.154A4.14 4.14 0 0 1 2 15.504c0-2.329 2.956-2.756 3.19-7.521C5.373 4.254 8.23 2.2 11.565 2.2 17.521 2.2 21.8 8.757 21.8 15.66zm-1 0c0-6.017-3.711-12.46-9.235-12.46-2.37 0-5.2 1.265-5.376 4.832a8.817 8.817 0 0 1-2.272 5.716C3.314 14.493 3 14.91 3 15.504c0 3.077 3.293 3.113 3.326 3.113a8.45 8.45 0 0 0 .89-.066 12.225 12.225 0 0 1 1.33-.088 10.29 10.29 0 0 1 4.465 1.2 9.621 9.621 0 0 0 4.235 1.137c.879 0 3.554 0 3.554-5.14z" />
		<path fill={fill} d="M17.246 20.8a9.621 9.621 0 0 1-4.235-1.137 10.29 10.29 0 0 0-4.464-1.2 12.225 12.225 0 0 0-1.331.088 8.45 8.45 0 0 1-.89.066C6.293 18.617 3 18.58 3 15.504c0-.594.314-1.01.917-1.756a8.817 8.817 0 0 0 2.272-5.716C6.364 4.465 9.194 3.2 11.565 3.2c5.524 0 9.235 6.443 9.235 12.46 0 5.14-2.675 5.14-3.554 5.14z" />
		<path fill="none" d="M0 0h24v24H0z" />
	</svg>
);

export const OnlyScheduledOrdersDuotoneIcon = ({ fill = "#666" }) => (
	<svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M9 20H6C3.79086 20 2 18.2091 2 16V7C2 4.79086 3.79086 3 6 3H17C19.2091 3 21 4.79086 21 7V10" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M8 2V4" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M15 2V4" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M2 8H21" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M18.5 15.6429L17 17.1429" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
		<circle cx="17" cy="17" r="5" stroke={fill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

export const GroupDropoffDuotoneIcon = ({ width = 24, height = 24, fill = "#666" }) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 24 24"
		fill="#bdbabd5e"
		xmlns="http://www.w3.org/2000/svg">
		<path d="M14.5 21V16C14.5 15.4477 14.0523 15 13.5 15H10.5C9.94772 15 9.5 15.4477 9.5 16V21" stroke={fill} fill={fill} strokeLinecap="round" strokeLinejoin="round" />
		<path d="M5 11V17C5 18.8856 5 19.8284 5.58579 20.4142C6.17157 21 7.11438 21 9 21H15C16.8856 21 17.8284 21 18.4142 20.4142C19 19.8284 19 18.8856 19 17V11" stroke="#666" />
		<path d="M4.62127 4.51493C4.80316 3.78737 4.8941 3.42359 5.16536 3.21179C5.43663 3 5.8116 3 6.56155 3H17.4384C18.1884 3 18.5634 3 18.8346 3.21179C19.1059 3.42359 19.1968 3.78737 19.3787 4.51493L20.5823 9.32938C20.6792 9.71675 20.7276 9.91044 20.7169 10.0678C20.6892 10.4757 20.416 10.8257 20.0269 10.9515C19.8769 11 19.6726 11 19.2641 11V11C18.7309 11 18.4644 11 18.2405 10.9478C17.6133 10.8017 17.0948 10.3625 16.8475 9.76781C16.7593 9.55555 16.7164 9.29856 16.6308 8.78457V8.78457C16.6068 8.64076 16.5948 8.56886 16.5812 8.54994C16.5413 8.49439 16.4587 8.49439 16.4188 8.54994C16.4052 8.56886 16.3932 8.64076 16.3692 8.78457L16.2877 9.27381C16.2791 9.32568 16.2747 9.35161 16.2704 9.37433C16.0939 10.3005 15.2946 10.9777 14.352 10.9995C14.3289 11 14.3026 11 14.25 11V11C14.1974 11 14.1711 11 14.148 10.9995C13.2054 10.9777 12.4061 10.3005 12.2296 9.37433C12.2253 9.35161 12.2209 9.32568 12.2123 9.27381L12.1308 8.78457C12.1068 8.64076 12.0948 8.56886 12.0812 8.54994C12.0413 8.49439 11.9587 8.49439 11.9188 8.54994C11.9052 8.56886 11.8932 8.64076 11.8692 8.78457L11.7877 9.27381C11.7791 9.32568 11.7747 9.35161 11.7704 9.37433C11.5939 10.3005 10.7946 10.9777 9.85199 10.9995C9.82887 11 9.80258 11 9.75 11V11C9.69742 11 9.67113 11 9.64801 10.9995C8.70541 10.9777 7.90606 10.3005 7.7296 9.37433C7.72527 9.35161 7.72095 9.32568 7.7123 9.27381L7.63076 8.78457C7.60679 8.64076 7.59481 8.56886 7.58122 8.54994C7.54132 8.49439 7.45868 8.49439 7.41878 8.54994C7.40519 8.56886 7.39321 8.64076 7.36924 8.78457V8.78457C7.28357 9.29856 7.24074 9.55555 7.15249 9.76781C6.90524 10.3625 6.38675 10.8017 5.75951 10.9478C5.53563 11 5.26905 11 4.73591 11V11C4.32737 11 4.12309 11 3.97306 10.9515C3.58403 10.8257 3.31078 10.4757 3.28307 10.0678C3.27239 9.91044 3.32081 9.71675 3.41765 9.32938L4.62127 4.51493Z" stroke="#666" />
	</svg>
);

export const DriverDuotoneIcon = ({ width = 21, height = 21, fill = "#666" }) => (
	<svg
		width={width}
		height={height} version="1.1" id="Layer_1"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 512 512" 		>
		<g>
			<path fill={fill} d="M288.581,338.898l30.718-72.926c6.283-14.922,6.357-27.949,0.202-35.741
		c-6.159-7.792-18.864-10.727-34.83-8.068L88.446,254.933v86.128L288.581,338.898z M260.775,268.889l28.261-28.261
		c3.68-3.68,9.641-3.68,13.321,0c3.68,3.68,3.68,9.641,0,13.321l-28.261,28.261c-1.84,1.84-4.25,2.76-6.661,2.76
		c-2.41,0-4.821-0.92-6.661-2.76C257.095,278.53,257.095,272.569,260.775,268.889z"/>
			<path fill="#bdbabd5e" d="M399.323,266.129c-10.391,0-18.841,8.454-18.841,18.841s8.45,18.841,18.841,18.841
		s18.841-8.454,18.841-18.841S409.714,266.129,399.323,266.129z"/>
		</g>
		<path fill="#bdbabd5e" d="M298.747,58.878h-15.52c-101.318,0-184.734,77.799-193.868,176.802l192.212-32.1
	c23.284-3.882,42.015,1.426,52.714,14.968s11.541,32.981,2.374,54.738l-33.114,78.621c-1.454,3.459-4.825,5.731-8.579,5.768
	l-206.033,2.222c2.382,41.469,17.776,81.111,44.338,113.124l332.417-90.81c2.76-11.067,4.581-22.364,5.428-33.653l7.194-96.091
	c3.873-51.794-12.664-100.442-46.564-136.974C397.864,78.989,350.633,58.878,298.747,58.878z M399.323,322.652
	c-20.778,0-37.682-16.9-37.682-37.682c0-20.782,16.904-37.682,37.682-37.682s37.682,16.9,37.682,37.682
	C437.004,305.752,420.1,322.652,399.323,322.652z"/>
		<g>
			<path fill="#666" d="M445.555,102.678c-37.484-40.396-89.624-62.641-146.809-62.641h-15.52
		c-115.157,0-209.266,91.624-213.422,205.81c-0.046,0.377-0.199,0.721-0.199,1.109v6.753v95.005v1.868
		c0,0.189,0.098,0.358,0.11,0.546c0.579,51.173,19.362,100.383,53.216,138.783c1.812,2.061,4.402,3.192,7.065,3.192
		c0.828,0,1.661-0.11,2.484-0.331l343.416-93.818c3.202-0.874,5.704-3.376,6.592-6.569c3.855-13.882,6.348-28.16,7.415-42.429
		l7.194-96.091C501.37,196.791,483.063,143.101,445.555,102.678z M284.671,222.163c15.966-2.659,28.671,0.276,34.83,8.068
		c6.155,7.792,6.081,20.819-0.202,35.741l-30.718,72.926L88.446,341.06v-86.128L284.671,222.163z M478.311,252.467l-7.194,96.091
		c-0.846,11.288-2.668,22.585-5.428,33.653l-332.417,90.81c-26.563-32.013-41.956-71.655-44.338-113.124l206.033-2.222
		c3.754-0.037,7.125-2.309,8.579-5.768l33.114-78.621c9.168-21.757,8.326-41.196-2.373-54.738s-29.43-18.85-52.714-14.968
		l-192.212,32.1c9.134-99.003,92.55-176.802,193.868-176.802h15.52c51.886,0,99.117,20.111,133,56.615
		C465.648,152.025,482.184,200.673,478.311,252.467z"/>
			<path fill="#666" d="M399.323,247.288c-20.778,0-37.682,16.9-37.682,37.682c0,20.782,16.904,37.682,37.682,37.682
		s37.682-16.9,37.682-37.682C437.004,264.188,420.1,247.288,399.323,247.288z M399.323,303.811
		c-10.391,0-18.841-8.454-18.841-18.841s8.45-18.841,18.841-18.841s18.841,8.454,18.841,18.841S409.714,303.811,399.323,303.811z"/>
			<path fill="#666" d="M267.436,284.97c2.41,0,4.821-0.92,6.661-2.76l28.261-28.261c3.68-3.68,3.68-9.641,0-13.321
		s-9.641-3.68-13.321,0l-28.261,28.261c-3.68,3.68-3.68,9.641,0,13.321C262.615,284.05,265.025,284.97,267.436,284.97z"/>
			<path fill="#666" d="M461.094,411.723L161.639,493.49c-5.023,1.371-7.981,6.55-6.61,11.573
		c1.145,4.186,4.94,6.937,9.085,6.937c0.819,0,1.656-0.11,2.484-0.331l299.455-81.767c5.023-1.371,7.981-6.55,6.61-11.573
		C471.287,413.315,466.089,410.362,461.094,411.723z"/>
		</g>
	</svg>
);

export const DropoffDuotoneIcon = ({ width = 21, height = 24, fill = "#666" }) => (
	<svg
		fill="none"
		version="1.1" id="Layer_1"
		xmlns="http://www.w3.org/2000/svg"
		width={width}
		height={height}
		viewBox="0 0 72 72"
		style={{ enableBackground: 'new 0 0 72 72' }}>
		<g>
			<path fill="#bdbabd5e" stroke="#666" strokeWidth="4" d="M36.001,3.262c-11.841,0-21.474,9.633-21.474,21.473c0,7.726,11.138,32.257,14.13,38.154c2.582,5.09,5.77,5.85,7.442,5.85
		c2.896,0,5.533-2.08,7.428-5.858c2.838-5.659,13.947-30.505,13.947-38.145C57.475,12.895,47.841,3.262,36.001,3.262z
		 "/>
			<path fill={fill} stroke="#666" strokeWidth="4" d="M36.118,15.934c-2.454,0-4.763,0.956-6.498,2.691c-3.582,3.582-3.582,9.41,0,12.992c1.737,1.735,4.045,2.691,6.5,2.691
		c2.453,0,4.762-0.956,6.496-2.691c3.582-3.582,3.582-9.41,0-12.992C40.882,16.89,38.573,15.934,36.118,15.934z M39.788,28.789
		c-0.979"/>
		</g>
	</svg>
);

export const FocusMapDuotoneIcon = ({ width = 21, height = 21, fill = "#666" }) => (
	<svg
		fill={fill}
		width={width}
		height={height}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg">
		<path d="m16 0c8.836556 0 16 7.163444 16 16s-7.163444 16-16 16-16-7.163444-16-16 7.163444-16 16-16zm1.0008661 2.0352252-.0008661 3.9647748c0 .55228475-.4477153 1-1 1s-1-.44771525-1-1l.0001337-3.96484538c-6.9350811.48937684-12.47560224 6.02989798-12.96497908 12.96497908l3.96484538-.0001337c.55228475 0 1 .4477153 1 1s-.44771525 1-1 1l-3.9647748.0008661c.48983875 6.9346138 6.03016066 12.474626 12.9649085 12.9639793l-.0001337-3.9648454c0-.5522847.4477153-1 1-1s1 .4477153 1 1l.0008661 3.9647748c6.9342805-.4898152 12.4740935-6.0296282 12.9639087-12.9639087l-3.9647748-.0008661c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1l3.9648454.0001337c-.4893533-6.93474784-6.0293655-12.47506975-12.9639793-12.9649085zm-1.0008661 8.9647748c2.7614237 0 5 2.2385763 5 5s-2.2385763 5-5 5-5-2.2385763-5-5 2.2385763-5 5-5zm0 2c-1.6568542 0-3 1.3431458-3 3s1.3431458 3 3 3 3-1.3431458 3-3-1.3431458-3-3-3z" />
	</svg>
);

export const ArrowUpDuotoneIcon = () => (
	<svg
		width="13"
		height="13"
		className="text-gray-800 dark:text-white transform rotate-180"
		aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="#7e7e7eff" viewBox="0 0 16 10">
		<path d="M15.434 1.235A2 2 0 0 0 13.586 0H2.414A2 2 0 0 0 1 3.414L6.586 9a2 2 0 0 0 2.828 0L15 3.414a2 2 0 0 0 .434-2.179Z" />
	</svg>
);

export const ArrowDownDuotoneIcon = () => (
	<svg
		width="13"
		height="13"
		className="text-gray-800 dark:text-white"
		aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="#7e7e7eff" viewBox="0 0 16 10">
		<path d="M15.434 1.235A2 2 0 0 0 13.586 0H2.414A2 2 0 0 0 1 3.414L6.586 9a2 2 0 0 0 2.828 0L15 3.414a2 2 0 0 0 .434-2.179Z" />
	</svg>
);

export const SearchDuotoneIcon = ({
	color = "#d68306ff",
	width = 22,
	height = 22
}) => (
	<svg
		fill="none"
		width={width}
		height={height}
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
	>
		<circle
			id="secondary"
			cx="10"
			cy="10"
			r="7"
			style={{ stroke: color, strokeWidth: 2 }}
		/>
		<path
			id="primary"
			d="M21,21l-6-6M10,3a7,7,0,1,0,7,7A7,7,0,0,0,10,3Z"
			style={{
				stroke: color,
				strokeLinecap: 'round',
				strokeLinejoin: 'round',
				strokeWidth: 2
			}}
		/>
	</svg>
);

export const SearchCloseDuotoneIcon = () => (
	<svg
		fill="#d68306ff"
		width="22"
		height="22"
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			id="primary"
			d="M21,21l-6-6M10,3a7,7,0,1,0,7,7A7,7,0,0,0,10,3Z"
			style={{
				fill: 'none',
				stroke: '#d68306ff',
				strokeLinecap: 'round',
				strokeLinejoin: 'round',
				strokeWidth: 2
			}}
		/>

		<line x1="7.5" y1="7.5" x2="12.5" y2="12.5" stroke="#d68306ff" strokeWidth="1.5" strokeLinecap="round" />
		<line x1="12.5" y1="7.5" x2="7.5" y2="12.5" stroke="#d68306ff" strokeWidth="1.5" strokeLinecap="round" />
	</svg>
);

export const ResetViewportDuotoneIcon = ({ fill = "#666" }) => (
	<svg width="24" height="24" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="24" cy="24" r="9" fill="#bdbabd5e" stroke={fill} strokeWidth="3" />
		<circle r="3" transform="matrix(-1 0 0 1 24 24)" fill="white" />
		<path d="M9 14C9 14 16.5 2.49997 29.5 6.99998C42.5 11.5 42 24.5 42 24.5" stroke={fill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M39 34C39 34 33 45 19.5 41.5C6 38 6 24 6 24" stroke={fill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M42 8V24" stroke={fill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M6 24L6 40" stroke={fill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

// simple svg

export const LocationSearch = () => (
	<svg
		width='20'
		height='20' viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" >
		<path fill="#FF9800" d="M8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM7 14v-5h-5l10-5-5 10z"></path>
	</svg>
);



export const FilterIcon = () => (
	<svg
		width='20'
		height='20'
		viewBox='0 0 20 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z'
			fill='black'
			fillOpacity='0.38'
		/>
	</svg>
);

export const MergeOrderIcon = ({ width = 24, height = 24 }) => (
	<svg fill="transparent"
		width={width}
		height={height}
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg">
		<path d="M14.5 21V16C14.5 15.4477 14.0523 15 13.5 15H10.5C9.94772 15 9.5 15.4477 9.5 16V21" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M5 11V17C5 18.8856 5 19.8284 5.58579 20.4142C6.17157 21 7.11438 21 9 21H15C16.8856 21 17.8284 21 18.4142 20.4142C19 19.8284 19 18.8856 19 17V11" stroke="#666" strokeWidth="2" />
		<path d="M4.62127 4.51493C4.80316 3.78737 4.8941 3.42359 5.16536 3.21179C5.43663 3 5.8116 3 6.56155 3H17.4384C18.1884 3 18.5634 3 18.8346 3.21179C19.1059 3.42359 19.1968 3.78737 19.3787 4.51493L20.5823 9.32938C20.6792 9.71675 20.7276 9.91044 20.7169 10.0678C20.6892 10.4757 20.416 10.8257 20.0269 10.9515C19.8769 11 19.6726 11 19.2641 11V11C18.7309 11 18.4644 11 18.2405 10.9478C17.6133 10.8017 17.0948 10.3625 16.8475 9.76781C16.7593 9.55555 16.7164 9.29856 16.6308 8.78457V8.78457C16.6068 8.64076 16.5948 8.56886 16.5812 8.54994C16.5413 8.49439 16.4587 8.49439 16.4188 8.54994C16.4052 8.56886 16.3932 8.64076 16.3692 8.78457L16.2877 9.27381C16.2791 9.32568 16.2747 9.35161 16.2704 9.37433C16.0939 10.3005 15.2946 10.9777 14.352 10.9995C14.3289 11 14.3026 11 14.25 11V11C14.1974 11 14.1711 11 14.148 10.9995C13.2054 10.9777 12.4061 10.3005 12.2296 9.37433C12.2253 9.35161 12.2209 9.32568 12.2123 9.27381L12.1308 8.78457C12.1068 8.64076 12.0948 8.56886 12.0812 8.54994C12.0413 8.49439 11.9587 8.49439 11.9188 8.54994C11.9052 8.56886 11.8932 8.64076 11.8692 8.78457L11.7877 9.27381C11.7791 9.32568 11.7747 9.35161 11.7704 9.37433C11.5939 10.3005 10.7946 10.9777 9.85199 10.9995C9.82887 11 9.80258 11 9.75 11V11C9.69742 11 9.67113 11 9.64801 10.9995C8.70541 10.9777 7.90606 10.3005 7.7296 9.37433C7.72527 9.35161 7.72095 9.32568 7.7123 9.27381L7.63076 8.78457C7.60679 8.64076 7.59481 8.56886 7.58122 8.54994C7.54132 8.49439 7.45868 8.49439 7.41878 8.54994C7.40519 8.56886 7.39321 8.64076 7.36924 8.78457V8.78457C7.28357 9.29856 7.24074 9.55555 7.15249 9.76781C6.90524 10.3625 6.38675 10.8017 5.75951 10.9478C5.53563 11 5.26905 11 4.73591 11V11C4.32737 11 4.12309 11 3.97306 10.9515C3.58403 10.8257 3.31078 10.4757 3.28307 10.0678C3.27239 9.91044 3.32081 9.71675 3.41765 9.32938L4.62127 4.51493Z" stroke="#666" strokeWidth="2" />
	</svg>
);

export const MenuIcon = () => (
	<svg
		width='32'
		height='32'
		viewBox='0 0 32 32'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M4 24H28V21.3333H4V24ZM4 17.3333H28V14.6667H4V17.3333ZM4 8V10.6667H28V8H4Z'
			fill='#5C4BC6'
		/>
	</svg>
);

export const ArrowUpIcon = () => (
	<svg
		fill="#a4a4a4"
		width="24"
		height="28"
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg">
		<g transform="translate(6,6) rotate(-90, 6, 6)">
			<path d="M2.29289 2.29289C2.68342 1.90237 3.31658 1.90237 3.70711 2.29289L8.20711 6.79289C8.59763 7.18342 8.59763 7.81658 8.20711 8.20711L3.70711 12.7071C3.31658 13.0976 2.68342 13.0976 2.29289 12.7071C1.90237 12.3166 1.90237 11.6834 2.29289 11.2929L5 8.5H-4.5C-5.05228 8.5 -5.5 8.05228 -5.5 7.5C-5.5 6.94772 -5.05228 6.5 -4.5 6.5H5L2.29289 3.70711C1.90237 3.31658 1.90237 2.68342 2.29289 2.29289Z" />
		</g>
	</svg>
);

export const DropOffIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 90 90"
		fill="#d94949"
	>
		<path
			d="M 45 10 
           c 12 0 22 10 22 22 
           C 67 44 47 60 45 80 
           C 43 60 23 44 23 32 
           C 23 20 33 10 45 10 
           z"
		/>
	</svg>
);

export const EyeIcon = () => (
	<svg
		fill="#a4a4a4"
		width="24"
		height="28"
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path fillRule="evenodd" clipRule="evenodd" d="M1 10c0-3.9 3.1-7 7-7s7 3.1 7 7h-1c0-3.3-2.7-6-6-6s-6 2.7-6 6H1zm4 0c0-1.7 1.3-3 3-3s3 1.3 3 3-1.3 3-3 3-3-1.3-3-3zm1 0c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2z" />
	</svg>
);

export const EyeSlashIcon = () => (
	<svg
		fill="#a4a4a4"
		width="24"
		height="28"
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path fillRule="evenodd" clipRule="evenodd" d="M1 10c0-3.9 3.1-7 7-7s7 3.1 7 7h-1c0-3.3-2.7-6-6-6s-6 2.7-6 6H1zm4 0c0-1.7 1.3-3 3-3s3 1.3 3 3-1.3 3-3 3-3-1.3-3-3zm1 0c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2z" />
		<line x1="18" y1="1" x2="1" y2="17" stroke="#ff9800" strokeWidth="1" />
	</svg>
);

export const MapLocationPinIcon = () => (
	<svg
		fill="#a4a4a4"
		width="24"
		height="28"
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path fillRule="evenodd" clipRule="evenodd" d="M1 10c0-3.9 3.1-7 7-7s7 3.1 7 7h-1c0-3.3-2.7-6-6-6s-6 2.7-6 6H1zm4 0c0-1.7 1.3-3 3-3s3 1.3 3 3-1.3 3-3 3-3-1.3-3-3zm1 0c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2z" />
	</svg>
);

export const ArrowDownIcon = () => (
	<svg
		fill="#a4a4a4"
		width="24"
		height="28"
		viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
		<g transform="translate(10,10) rotate(90, 6, 6)">
			<path d="M8.29289 2.29289C8.68342 1.90237 9.31658 1.90237 9.70711 2.29289L14.2071 6.79289C14.5976 7.18342 14.5976 7.81658 14.2071 8.20711L9.70711 12.7071C9.31658 13.0976 8.68342 13.0976 8.29289 12.7071C7.90237 12.3166 7.90237 11.6834 8.29289 11.2929L11 8.5H1.5C0.947715 8.5 0.5 8.05228 0.5 7.5C0.5 6.94772 0.947715 6.5 1.5 6.5H11L8.29289 3.70711C7.90237 3.31658 7.90237 2.68342 8.29289 2.29289Z" />
		</g>
	</svg>
);

export const SearchIcon = () => (
	<svg
		width='18'
		height='18'
		viewBox='0 0 18 18'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<circle
			cx='8.25'
			cy='8.25'
			r='5.25'
			stroke='#A4A4A4'
			strokeWidth='1.5'
		/>
		<path
			d='M15 15L12.75 12.75'
			stroke='#A4A4A4'
			strokeWidth='1.5'
			strokeLinecap='round'
		/>
	</svg>
);

export const TickIcon = () => (
	<svg
		width='19'
		height='14'
		viewBox='0 0 19 14'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M6.50016 11.17L2.33016 7L0.910156 8.41L6.50016 14L18.5002 2L17.0902 0.589996L6.50016 11.17Z'
			fill='white'
		/>
	</svg>
);

export const CompletedNeigbourhoodIcon = () => (
	<svg
		width='14'
		height='14'
		viewBox='0 0 14 14'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M6.99992 0.333328C3.31992 0.333328 0.333252 3.31999 0.333252 7C0.333252 10.68 3.31992 13.6667 6.99992 13.6667C10.6799 13.6667 13.6666 10.68 13.6666 7C13.6666 3.31999 10.6799 0.333328 6.99992 0.333328ZM5.66659 10.3333L2.33325 7L3.27325 6.06L5.66659 8.44666L10.7266 3.38666L11.6666 4.33333L5.66659 10.3333Z'
			fill='#4CAF50'
		/>
	</svg>
);

export const ResetFilterIcon = ({ color = "black" }) => (
	<svg
		width="22"
		height="22"
		viewBox="0 0 18 18"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g transform="translate(0.75, 0.75)">
			<path
				d="M9 1.5C5.2725 1.5 2.25 4.5225 2.25 8.25H0L2.9175 11.1675L2.97 11.2725L6 8.25H3.75C3.75 5.3475 6.0975 3 9 3C11.9025 3 14.25 5.3475 14.25 8.25C14.25 11.1525 11.9025 13.5 9 13.5C7.5525 13.5 6.24 12.9075 5.295 11.955L4.23 13.02C5.4525 14.2425 7.1325 15 9 15C12.7275 15 15.75 11.9775 15.75 8.25C15.75 4.5225 12.7275 1.5 9 1.5ZM8.25 5.25V9L11.46 10.905L12 9.9975L9.375 8.4375V5.25H8.25Z"
				fill={color}
				fill-opacity="0.6"
			/>
		</g>
	</svg>
);

export const ResetIcon = ({ color = "#046172ff" }) => (
	<svg
		width='21'
		height='21'
		viewBox='0 0 18 18'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M9.75 2.25C6.0225 2.25 3 5.2725 3 9H0.75L3.6675 11.9175L3.72 12.0225L6.75 9H4.5C4.5 6.0975 6.8475 3.75 9.75 3.75C12.6525 3.75 15 6.0975 15 9C15 11.9025 12.6525 14.25 9.75 14.25C8.3025 14.25 6.99 13.6575 6.045 12.705L4.98 13.77C6.2025 14.9925 7.8825 15.75 9.75 15.75C13.4775 15.75 16.5 12.7275 16.5 9C16.5 5.2725 13.4775 2.25 9.75 2.25ZM9 6V9.75L12.21 11.655L12.75 10.7475L10.125 9.1875V6H9Z'
			fill={color}
		/>
	</svg>
);

export const PinIcon = () => (
	<svg
		width='24'
		height='24'
		viewBox='0 0 24 24'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<circle cx='12' cy='12' r='12' fill='#EEEEEE' />
		<path
			d='M18.6035 10.1133C18.4531 10.2637 18.3062 10.4015 18.1626 10.5269C18.019 10.6522 17.8709 10.7581 17.7183 10.8447C17.5656 10.9313 17.3993 10.9985 17.2192 11.0464C17.0392 11.0942 16.8353 11.1182 16.6074 11.1182C16.4525 11.1182 16.3044 11.1045 16.1631 11.0771L13.5723 13.668C13.6315 13.8411 13.6748 14.0189 13.7021 14.2012C13.7295 14.3835 13.7432 14.5658 13.7432 14.748C13.7432 15.0443 13.7135 15.3132 13.6543 15.5547C13.5951 15.7962 13.5096 16.0241 13.3979 16.2383C13.2863 16.4525 13.1507 16.6564 12.9912 16.8501C12.8317 17.0438 12.6517 17.2409 12.4512 17.4414L9.8125 14.8027L5.92969 18.6924L5 19L5.30762 18.0703L9.19727 14.1875L6.55859 11.5488L6.86621 11.2412C7.18522 10.9222 7.55094 10.6784 7.96338 10.5098C8.37581 10.3411 8.80762 10.2568 9.25879 10.2568C9.63249 10.2568 9.99023 10.3138 10.332 10.4277L12.9229 7.83691C12.8955 7.69564 12.8818 7.54753 12.8818 7.39258C12.8818 7.16927 12.9058 6.96761 12.9536 6.7876C13.0015 6.60758 13.0687 6.4401 13.1553 6.28516C13.2419 6.13021 13.3478 5.98096 13.4731 5.8374C13.5985 5.69385 13.7363 5.54688 13.8867 5.39648L18.6035 10.1133ZM16.6074 10.2432C16.8581 10.2432 17.0951 10.1839 17.3184 10.0654L13.9346 6.68164C13.8161 6.90495 13.7568 7.14193 13.7568 7.39258C13.7568 7.52018 13.7716 7.63981 13.8013 7.75146C13.8309 7.86312 13.8639 7.97819 13.9004 8.09668L10.5371 11.4531C10.4232 11.4076 10.3161 11.3643 10.2158 11.3232C10.1156 11.2822 10.0153 11.248 9.91504 11.2207C9.81478 11.1934 9.7111 11.1717 9.604 11.1558C9.49691 11.1398 9.38184 11.1318 9.25879 11.1318C8.99902 11.1318 8.74723 11.1694 8.50342 11.2446C8.2596 11.3198 8.03288 11.4303 7.82324 11.5762L12.4238 16.1768C12.5697 15.9671 12.6813 15.7404 12.7588 15.4966C12.8363 15.2528 12.875 15.0033 12.875 14.748C12.875 14.625 12.867 14.5099 12.8511 14.4028C12.8351 14.2957 12.8123 14.1909 12.7827 14.0884C12.7531 13.9858 12.7178 13.8844 12.6768 13.7842C12.6357 13.6839 12.5924 13.5768 12.5469 13.4629L15.9033 10.0996C16.0218 10.1361 16.1369 10.1691 16.2485 10.1987C16.3602 10.2284 16.4798 10.2432 16.6074 10.2432Z'
			fill='black'
			fillOpacity='0.54'
		/>
	</svg>
);

export const CheckedPinIcon = () => (
	<svg
		width='24'
		height='24'
		viewBox='0 0 24 24'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<circle cx='12' cy='12' r='12' fill='#3F51B5' />
		<path
			d='M18.6035 10.1133C18.4531 10.2637 18.3062 10.4015 18.1626 10.5269C18.019 10.6522 17.8709 10.7581 17.7183 10.8447C17.5656 10.9313 17.3993 10.9985 17.2192 11.0464C17.0392 11.0942 16.8353 11.1182 16.6074 11.1182C16.4525 11.1182 16.3044 11.1045 16.1631 11.0771L13.5723 13.668C13.6315 13.8411 13.6748 14.0189 13.7021 14.2012C13.7295 14.3835 13.7432 14.5658 13.7432 14.748C13.7432 15.0443 13.7135 15.3132 13.6543 15.5547C13.5951 15.7962 13.5096 16.0241 13.3979 16.2383C13.2863 16.4525 13.1507 16.6564 12.9912 16.8501C12.8317 17.0438 12.6517 17.2409 12.4512 17.4414L9.8125 14.8027L5.92969 18.6924L5 19L5.30762 18.0703L9.19727 14.1875L6.55859 11.5488L6.86621 11.2412C7.18522 10.9222 7.55094 10.6784 7.96338 10.5098C8.37581 10.3411 8.80762 10.2568 9.25879 10.2568C9.63249 10.2568 9.99023 10.3138 10.332 10.4277L12.9229 7.83691C12.8955 7.69564 12.8818 7.54753 12.8818 7.39258C12.8818 7.16927 12.9058 6.96761 12.9536 6.7876C13.0015 6.60758 13.0687 6.4401 13.1553 6.28516C13.2419 6.13021 13.3478 5.98096 13.4731 5.8374C13.5985 5.69385 13.7363 5.54688 13.8867 5.39648L18.6035 10.1133ZM16.6074 10.2432C16.8581 10.2432 17.0951 10.1839 17.3184 10.0654L13.9346 6.68164C13.8161 6.90495 13.7568 7.14193 13.7568 7.39258C13.7568 7.52018 13.7716 7.63981 13.8013 7.75146C13.8309 7.86312 13.8639 7.97819 13.9004 8.09668L10.5371 11.4531C10.4232 11.4076 10.3161 11.3643 10.2158 11.3232C10.1156 11.2822 10.0153 11.248 9.91504 11.2207C9.81478 11.1934 9.7111 11.1717 9.604 11.1558C9.49691 11.1398 9.38184 11.1318 9.25879 11.1318C8.99902 11.1318 8.74723 11.1694 8.50342 11.2446C8.2596 11.3198 8.03288 11.4303 7.82324 11.5762L12.4238 16.1768C12.5697 15.9671 12.6813 15.7404 12.7588 15.4966C12.8363 15.2528 12.875 15.0033 12.875 14.748C12.875 14.625 12.867 14.5099 12.8511 14.4028C12.8351 14.2957 12.8123 14.1909 12.7827 14.0884C12.7531 13.9858 12.7178 13.8844 12.6768 13.7842C12.6357 13.6839 12.5924 13.5768 12.5469 13.4629L15.9033 10.0996C16.0218 10.1361 16.1369 10.1691 16.2485 10.1987C16.3602 10.2284 16.4798 10.2432 16.6074 10.2432Z'
			fill='white'
		/>
	</svg>
);

export const AlertIcon = () => (
	<svg
		width='32'
		height='32'
		viewBox='0 0 32 32'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<circle cx='16' cy='16' r='16' fill='#F50057' fillOpacity='0.08' />
		<path
			d='M15 19H17V21H15V19ZM15 11H17V17H15V11ZM15.99 6C10.47 6 6 10.48 6 16C6 21.52 10.47 26 15.99 26C21.52 26 26 21.52 26 16C26 10.48 21.52 6 15.99 6ZM16 24C11.58 24 8 20.42 8 16C8 11.58 11.58 8 16 8C20.42 8 24 11.58 24 16C24 20.42 20.42 24 16 24Z'
			fill='#F44336'
		/>
	</svg>
);

export const AcceptedStatusIcon = () => (
	<svg
		width='32'
		height='32'
		viewBox='0 0 32 32'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<circle cx='16' cy='16' r='16' fill='#4CAF50' fillOpacity='0.08' />
		<path
			d='M13 20.17L8.83003 16L7.41003 17.41L13 23L25 11L23.59 9.59L13 20.17Z'
			fill='#7BC67E'
		/>
	</svg>
);

export const AssignedStatusIcon = () => (
	<svg
		width='32'
		height='32'
		viewBox='0 0 32 32'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<circle cx='16' cy='16' r='16' fill='#3F51B5' fillOpacity='0.08' />
		<path
			d='M22.92 10.01C22.72 9.42 22.16 9 21.5 9H10.5C9.84 9 9.29 9.42 9.08 10.01L7 16V24C7 24.55 7.45 25 8 25H9C9.55 25 10 24.55 10 24V23H22V24C22 24.55 22.45 25 23 25H24C24.55 25 25 24.55 25 24V16L22.92 10.01ZM10.5 20C9.67 20 9 19.33 9 18.5C9 17.67 9.67 17 10.5 17C11.33 17 12 17.67 12 18.5C12 19.33 11.33 20 10.5 20ZM21.5 20C20.67 20 20 19.33 20 18.5C20 17.67 20.67 17 21.5 17C22.33 17 23 17.67 23 18.5C23 19.33 22.33 20 21.5 20ZM9 15L10.5 10.5H21.5L23 15H9Z'
			fill='#7986CB'
		/>
	</svg>
);

export const UnassignedStatusIcon = () => (
	<svg
		width='32'
		height='32'
		viewBox='0 0 32 32'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<circle cx='16' cy='16' r='16' fill='#F44336' fillOpacity='0.08' />
		<path
			d='M21.21 13L16.83 6.43999C16.64 6.15999 16.32 6.01999 16 6.01999C15.68 6.01999 15.36 6.15999 15.17 6.44999L10.79 13H6C5.45 13 5 13.45 5 14C5 14.09 5.01 14.18 5.04 14.27L7.58 23.54C7.81 24.38 8.58 25 9.5 25H22.5C23.42 25 24.19 24.38 24.43 23.54L26.97 14.27L27 14C27 13.45 26.55 13 26 13H21.21ZM13 13L16 8.59999L19 13H13ZM16 21C14.9 21 14 20.1 14 19C14 17.9 14.9 17 16 17C17.1 17 18 17.9 18 19C18 20.1 17.1 21 16 21Z'
			fill='#F88078'
		/>
	</svg>
);

export const OnHoldStatusIcon = () => (
	<svg
		width='32'
		height='32'
		viewBox='0 0 32 32'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<circle cx='16' cy='16' r='16' fill='#FF9800' fillOpacity='0.08' />
		<path
			d='M13 20H15V12H13V20ZM16 6C10.48 6 6 10.48 6 16C6 21.52 10.48 26 16 26C21.52 26 26 21.52 26 16C26 10.48 21.52 6 16 6ZM16 24C11.59 24 8 20.41 8 16C8 11.59 11.59 8 16 8C20.41 8 24 11.59 24 16C24 20.41 20.41 24 16 24ZM17 20H19V12H17V20Z'
			fill='#FFB547'
		/>
	</svg>
);

export const CompletedStatusIcon = () => (
	<svg
		width='32'
		height='32'
		viewBox='0 0 32 32'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<circle cx='16' cy='16' r='16' fill='#4CAF50' fillOpacity='0.08' />
		<path
			d='M22 11L20.59 9.59L14.25 15.93L15.66 17.34L22 11ZM26.24 9.59L15.66 20.17L11.48 16L10.07 17.41L15.66 23L27.66 11L26.24 9.59ZM4.41003 17.41L10 23L11.41 21.59L5.83003 16L4.41003 17.41Z'
			fill='#4CAF50'
		/>
	</svg>
);

export const CancelledStatusIcon = () => (
	<svg
		width='32'
		height='32'
		viewBox='0 0 32 32'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<circle cx='16' cy='16' r='16' fill='#F5F5F5' />
		<path
			d='M23 10.41L21.59 9L16 14.59L10.41 9L9 10.41L14.59 16L9 21.59L10.41 23L16 17.41L21.59 23L23 21.59L17.41 16L23 10.41Z'
			fill='black'
			fillOpacity='0.54'
		/>
	</svg>
);

export const OpenHubIcon = () => (
	<svg
		width='18'
		height='18'
		viewBox='0 0 18 18'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M9 12.75C9.825 12.75 10.5 12.075 10.5 11.25C10.5 10.425 9.825 9.75 9 9.75C8.175 9.75 7.5 10.425 7.5 11.25C7.5 12.075 8.175 12.75 9 12.75ZM13.5 6H12.75V4.5C12.75 2.43 11.07 0.75 9 0.75C6.93 0.75 5.25 2.43 5.25 4.5H6.675C6.675 3.2175 7.7175 2.175 9 2.175C10.2825 2.175 11.325 3.2175 11.325 4.5V6H4.5C3.675 6 3 6.675 3 7.5V15C3 15.825 3.675 16.5 4.5 16.5H13.5C14.325 16.5 15 15.825 15 15V7.5C15 6.675 14.325 6 13.5 6ZM13.5 15H4.5V7.5H13.5V15Z'
			fill='black'
			fillOpacity='0.26'
		/>
	</svg>
);

export const CloseHubIcon = () => (
	<svg
		width='18'
		height='18'
		viewBox='0 0 18 18'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M13.5 6H12.75V4.5C12.75 2.43 11.07 0.75 9 0.75C6.93 0.75 5.25 2.43 5.25 4.5V6H4.5C3.675 6 3 6.675 3 7.5V15C3 15.825 3.675 16.5 4.5 16.5H13.5C14.325 16.5 15 15.825 15 15V7.5C15 6.675 14.325 6 13.5 6ZM9 12.75C8.175 12.75 7.5 12.075 7.5 11.25C7.5 10.425 8.175 9.75 9 9.75C9.825 9.75 10.5 10.425 10.5 11.25C10.5 12.075 9.825 12.75 9 12.75ZM11.325 6H6.675V4.5C6.675 3.2175 7.7175 2.175 9 2.175C10.2825 2.175 11.325 3.2175 11.325 4.5V6Z'
			fill='#F44336'
		/>
	</svg>
);

export const DropDownIcon = () => (
	<svg
		width='10'
		height='5'
		viewBox='0 0 10 5'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M0.833252 0.333496L4.99992 4.50016L9.16659 0.333496H0.833252Z'
			fill='white'
		/>
	</svg>
);

export const CartIcon = () => (
	<svg
		width='20'
		height='20'
		viewBox='0 0 20 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M9.16668 7.49992H10.8333V4.99992H13.3333V3.33325H10.8333V0.833252H9.16668V3.33325H6.66668V4.99992H9.16668V7.49992ZM5.83334 14.9999C4.91668 14.9999 4.17501 15.7499 4.17501 16.6666C4.17501 17.5833 4.91668 18.3333 5.83334 18.3333C6.75001 18.3333 7.50001 17.5833 7.50001 16.6666C7.50001 15.7499 6.75001 14.9999 5.83334 14.9999ZM14.1667 14.9999C13.25 14.9999 12.5083 15.7499 12.5083 16.6666C12.5083 17.5833 13.25 18.3333 14.1667 18.3333C15.0833 18.3333 15.8333 17.5833 15.8333 16.6666C15.8333 15.7499 15.0833 14.9999 14.1667 14.9999ZM5.97501 12.2916L6.00001 12.1916L6.75001 10.8333H12.9583C13.5833 10.8333 14.1333 10.4916 14.4167 9.97492L17.6333 4.13325L16.1833 3.33325H16.175L15.2583 4.99992L12.9583 9.16658H7.10834L7.00001 8.94158L5.13334 4.99992L4.34168 3.33325L3.55834 1.66659H0.833344V3.33325H2.50001L5.50001 9.65825L4.37501 11.6999C4.24168 11.9333 4.16668 12.2083 4.16668 12.4999C4.16668 13.4166 4.91668 14.1666 5.83334 14.1666H15.8333V12.4999H6.18334C6.07501 12.4999 5.97501 12.4083 5.97501 12.2916Z'
			fill='#FF9800'
		/>
	</svg>
);

export const WarehouseOrangeIcon = () => (
	<svg
		width='12'
		height='12'
		viewBox='0 0 12 12'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M5.84131 0.039952C5.68617 0.123842 0.13753 4.08251 0.08104 4.14964C0.0487033 4.18803 0.0160617 4.25341 0.00846412 4.29492C0.000866521 4.33645 -0.0021819 4.7942 0.0016638 5.31217C0.00846412 6.22535 0.0101525 6.25594 0.0577313 6.32007C0.138866 6.42949 0.250274 6.4917 0.365059 6.4917C0.486597 6.4917 0.549418 6.46186 0.78764 6.29101C0.885401 6.2209 0.974344 6.16354 0.985319 6.16354C0.996293 6.16354 1.00527 7.39279 1.00527 8.89519C1.00527 11.5371 1.00675 11.6297 1.05002 11.7138C1.10758 11.8257 1.2053 11.9177 1.31523 11.9636C1.38567 11.993 1.5084 12 1.95422 12H2.50604V8.99973V5.99947H5.99999H9.49395V8.99973V12L10.0509 11.9995C10.6647 11.9989 10.7248 11.9874 10.8586 11.8447C11.0025 11.6913 10.9947 11.8623 10.9947 8.87175V6.14046L11.2529 6.31609C11.4864 6.47489 11.522 6.4917 11.6246 6.4917C11.7504 6.4917 11.8582 6.43343 11.9423 6.32007C11.9898 6.2559 11.9915 6.22535 11.9985 5.30045C12.0031 4.69301 11.9969 4.31695 11.9815 4.26428C11.9682 4.21878 11.9228 4.14875 11.8805 4.10864C11.7772 4.01055 6.20096 0.0497263 6.12615 0.0212941C6.03643 -0.0127871 5.92543 -0.00552081 5.84131 0.039952ZM3.25642 7.37068V7.99183H5.99999H8.74357V7.37068V6.74953H5.99999H3.25642V7.37068ZM3.25642 9.37477V10.0076H5.99999H8.74357V9.37477V8.7419H5.99999H3.25642V9.37477ZM3.25642 11.3789V12H5.99999H8.74357V11.3789V10.7577H5.99999H3.25642V11.3789Z'
			fill='#FF9800'
		/>
	</svg>
);

export const SaveIcon = () => (
	<svg
		width='24'
		height='24'
		viewBox='0 0 24 24'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M17 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V7L17 3ZM12 19C10.34 19 9 17.66 9 16C9 14.34 10.34 13 12 13C13.66 13 15 14.34 15 16C15 17.66 13.66 19 12 19ZM15 9H5V5H15V9Z'
			fill='white'
		/>
	</svg>
);

export const LocationIcon = () => (
	<svg
		width='24'
		height='24'
		viewBox='0 0 24 24'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z'
			fill='black'
			fillOpacity='0.54'
		/>
	</svg>
);

export const RefreshIcon = () => (
	<svg
		width='24'
		height='24'
		viewBox='0 0 24 24'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M17.65 6.35C16.2 4.9 14.21 4 12 4C7.58001 4 4.01001 7.58 4.01001 12C4.01001 16.42 7.58001 20 12 20C15.73 20 18.84 17.45 19.73 14H17.65C16.83 16.33 14.61 18 12 18C8.69001 18 6.00001 15.31 6.00001 12C6.00001 8.69 8.69001 6 12 6C13.66 6 15.14 6.69 16.22 7.78L13 11H20V4L17.65 6.35Z'
			fill='black'
			fillOpacity='0.54'
		/>
	</svg>
);

export const PenIcon = () => (
	<svg
		width='18'
		height='18'
		viewBox='0 0 18 18'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M2.25 12.9375V15.75H5.0625L13.3575 7.455L10.545 4.6425L2.25 12.9375ZM15.5325 5.28C15.825 4.9875 15.825 4.515 15.5325 4.2225L13.7775 2.4675C13.485 2.175 13.0125 2.175 12.72 2.4675L11.3475 3.84L14.16 6.6525L15.5325 5.28Z'
			fill='#FF9800'
		/>
	</svg>
);

export const DefaultWarehouseIcon = () => (
	<svg
		width='42'
		height='42'
		viewBox='0 0 42 42'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M27.6856 11.0326C27.2524 11.1169 26.7822 11.4671 26.5359 11.8891C26.3608 12.1892 26.2974 12.4412 26.2997 12.8278C26.3013 13.0956 26.3219 13.2093 26.4059 13.4127C26.4933 13.6245 26.5019 13.675 26.4588 13.7256C25.4518 14.908 23.316 17.4039 23.2643 17.4587C23.1949 17.5324 23.1862 17.53 22.7908 17.3314C21.8054 16.8367 20.7743 16.771 19.6957 17.1344C19.4407 17.2202 19.2276 17.2851 19.2221 17.2784C19.2166 17.2718 18.8763 16.7619 18.4658 16.1454L17.7195 15.0244L17.8557 14.7571C18.0375 14.4004 18.0941 14.0826 18.0391 13.7271C17.9183 12.9466 17.3414 12.3618 16.5654 12.2332C15.4348 12.0458 14.3925 13.0883 14.5798 14.2191C14.7344 15.152 15.5637 15.7929 16.5037 15.7061L16.7578 15.6826L17.5124 16.8196L18.2671 17.9565L18.0144 18.2245C17.0999 19.1941 16.7002 20.5926 16.9919 21.8021C17.0229 21.9309 17.0357 22.0471 17.0204 22.0604C16.984 22.0919 14.0991 23.3083 14.0608 23.3083C14.0448 23.3083 13.928 23.2303 13.8012 23.135C12.7335 22.3322 11.2415 22.938 11.0219 24.2633C10.8346 25.3941 11.8769 26.4367 13.0075 26.2493C13.8035 26.1174 14.3697 25.5278 14.4867 24.7091L14.5314 24.3958L15.9472 23.7962C16.7258 23.4664 17.3969 23.1858 17.4384 23.1726C17.4983 23.1535 17.5508 23.2003 17.6922 23.3984C17.9072 23.6999 18.3985 24.1767 18.7157 24.3918C19.32 24.8016 19.9413 25.0196 20.6969 25.0869C20.8635 25.1017 20.9999 25.1256 20.9998 25.1398C20.9997 25.1541 21.0812 25.7358 21.1808 26.4324C21.3407 27.5506 21.3549 27.7029 21.3018 27.7326C20.9699 27.9184 20.6743 28.2731 20.5275 28.6617C20.2951 29.2772 20.4596 30.0077 20.9387 30.4868C21.9513 31.4996 23.6658 30.9306 23.9023 29.5032C24.0399 28.6721 23.5134 27.8458 22.6726 27.5736C22.554 27.5352 22.5233 27.5037 22.5055 27.4021C22.4536 27.1057 22.1729 25.0876 22.1729 25.0108C22.1729 24.942 22.2257 24.9057 22.4563 24.8163C23.0181 24.5984 23.5355 24.2504 23.9648 23.8017C24.101 23.6594 24.2242 23.543 24.2385 23.543C24.2529 23.543 24.9947 23.9555 25.8871 24.4595L27.5097 25.3759L27.4968 25.568C27.4235 26.6656 28.4362 27.5999 29.5067 27.4225C30.4658 27.2635 31.1317 26.3647 30.9779 25.4365C30.7669 24.1628 29.2895 23.5141 28.2745 24.2496L28.1124 24.3671L26.4686 23.44C25.0094 22.6171 24.8274 22.5038 24.8466 22.4316C24.8585 22.3868 24.9157 22.183 24.9737 21.9787C25.0677 21.6475 25.0791 21.5413 25.0793 21.001C25.0793 20.4678 25.0668 20.3478 24.975 20.0038C24.8516 19.5412 24.5588 18.9346 24.2815 18.5668L24.0826 18.303L25.7343 16.3768C26.7313 15.2142 27.4105 14.4533 27.4478 14.4572C27.4819 14.4607 27.6284 14.4853 27.7736 14.5118C27.9723 14.5481 28.1011 14.5495 28.2947 14.5174C29.5337 14.3121 30.1674 12.9729 29.5384 11.8891C29.1542 11.227 28.4232 10.8892 27.6856 11.0326Z'
			fill='black'
			fillOpacity='0.6'
		/>
	</svg>
);

export const SortIcon = ({ sortId }) => {
	if (parseInt(sortId) % 3 == 0) {
		return (
			<svg
				width='24'
				height='24'
				viewBox='0 0 24 24'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
			>
				<path
					d='M12 8L6 14L7.41 15.41L12 10.83L16.59 15.41L18 14L12 8Z'
					fill='#FF9800'
				/>
			</svg>
		);
	} else if (parseInt(sortId) % 3 == 1) {
		return (
			<svg
				width='24'
				height='24'
				viewBox='0 0 24 24'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
			>
				<path
					d='M16.59 8.59L12 13.17L7.41 8.59L6 10L12 16L18 10L16.59 8.59Z'
					fill='#FF9800'
				/>
			</svg>
		);
	} else {
		return (
			<svg
				width='10'
				height='18'
				viewBox='0 0 10 18'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
			>
				<path
					d='M5 2.83L8.17 6L9.58 4.59L5 0L0.410004 4.59L1.83 6L5 2.83ZM5 15.17L1.83 12L0.420004 13.41L5 18L9.59 13.41L8.17 12L5 15.17Z'
					fill='black'
					fillOpacity='0.26'
				/>
			</svg>
		);
	}
};

export const KnightIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<path d='M4.3913 0.714396C4.10429 0.832429 3.91469 0.99467 3.77926 1.23807C3.56982 1.61454 3.30059 1.76911 2.85293 1.76992C2.38262 1.77077 2.05628 1.9316 1.73277 2.3219C1.37416 2.75458 1.15119 3.2443 0.957374 4.02493C0.726167 4.95615 0.663821 5.73479 0.66355 7.69415L0.663425 8.66855H3.6025H6.54158V8.13989C6.54158 7.56181 6.52851 7.44912 6.43973 7.26174C6.37757 7.13058 6.14109 6.88334 5.70598 6.49468C5.59607 6.39649 5.46006 6.26562 5.40374 6.20382C5.30892 6.09979 4.28316 4.78396 4.2398 4.71074C4.22917 4.6928 4.28076 4.72606 4.35444 4.78465C4.52287 4.91859 4.72335 5.02843 4.88267 5.07405C5.02985 5.11622 5.32355 5.12055 5.45766 5.08254C5.50925 5.0679 5.63119 5.05625 5.72864 5.05663C5.9325 5.05742 6.03526 5.09033 6.26017 5.22685C6.34043 5.27556 6.47644 5.3498 6.56242 5.39184C6.70716 5.46258 6.7328 5.4683 6.9084 5.46871C7.08437 5.46913 7.10834 5.46392 7.24145 5.39618C7.3696 5.33098 7.4124 5.29099 7.64277 5.02101C7.98456 4.62047 8.03871 4.50223 7.97893 4.28699C7.93768 4.1385 8.04236 4.22733 6.15595 2.73999C5.60566 2.30612 5.10034 1.89854 5.03304 1.83428C4.76146 1.575 4.66557 1.34652 4.66557 0.958675C4.66557 0.796872 4.65717 0.706518 4.64056 0.689906C4.60308 0.652431 4.52274 0.66033 4.3913 0.714396ZM0.871891 9.35893C0.84323 9.37037 0.79758 9.40026 0.770462 9.42535C0.743343 9.45047 0.557139 9.79927 0.356656 10.2005C0.0112003 10.8919 -0.00735119 10.9351 0.00154941 11.0281C0.0128054 11.1455 0.0872203 11.2529 0.191568 11.3024C0.258145 11.334 0.543152 11.3364 3.69311 11.3314C7.11976 11.326 7.1222 11.326 7.17973 11.283C7.27353 11.213 7.31805 11.1373 7.32827 11.0305C7.33748 10.9344 7.32202 10.8982 6.97341 10.2005C6.77293 9.79927 6.58672 9.45051 6.55961 9.4255C6.53249 9.40047 6.4839 9.36997 6.45163 9.35776C6.37284 9.32791 0.946827 9.32906 0.871891 9.35893Z' />
		</SvgIcon>
	);
};

export const AvatarIcon = () => (
	<svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M7.99984 8.00033C9.47317 8.00033 10.6665 6.80699 10.6665 5.33366C10.6665 3.86033 9.47317 2.66699 7.99984 2.66699C6.5265 2.66699 5.33317 3.86033 5.33317 5.33366C5.33317 6.80699 6.5265 8.00033 7.99984 8.00033ZM7.99984 9.33366C6.21984 9.33366 2.6665 10.227 2.6665 12.0003V13.3337H13.3332V12.0003C13.3332 10.227 9.77984 9.33366 7.99984 9.33366Z" fill="black" fill-opacity="0.54" />
	</svg>
)

export const PeopleIcon = () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M7.99333 1.33301C4.31333 1.33301 1.32666 4.31967 1.32666 7.99967C1.32666 11.6797 4.31333 14.6663 7.99333 14.6663C11.6733 14.6663 14.66 11.6797 14.66 7.99967C14.66 4.31967 11.6733 1.33301 7.99333 1.33301V1.33301ZM10.4 5.55967C11.1133 5.55967 11.6867 6.13301 11.6867 6.84634C11.6867 7.55968 11.1133 8.13301 10.4 8.13301C9.68666 8.13301 9.11333 7.55968 9.11333 6.84634C9.10666 6.13301 9.68666 5.55967 10.4 5.55967V5.55967ZM6.39999 4.50634C7.26666 4.50634 7.97333 5.21301 7.97333 6.07967C7.97333 6.94634 7.26666 7.65301 6.39999 7.65301C5.53333 7.65301 4.82666 6.94634 4.82666 6.07967C4.82666 5.20634 5.52666 4.50634 6.39999 4.50634ZM6.39999 10.593V13.093C4.79999 12.593 3.53333 11.3597 2.97333 9.78634C3.67333 9.03967 5.41999 8.65967 6.39999 8.65967C6.75333 8.65967 7.19999 8.71301 7.66666 8.80634C6.57333 9.38634 6.39999 10.153 6.39999 10.593ZM7.99333 13.333C7.81333 13.333 7.63999 13.3263 7.46666 13.3063V10.593C7.46666 9.64634 9.42666 9.17301 10.4 9.17301C11.1133 9.17301 12.3467 9.43301 12.96 9.93967C12.18 11.9197 10.2533 13.333 7.99333 13.333V13.333Z" fill="black" fill-opacity="0.54" />
	</svg>
)

export const VehicleIcon = () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M12.6133 4.00634C12.48 3.61301 12.1067 3.33301 11.6667 3.33301H4.33333C3.89333 3.33301 3.52667 3.61301 3.38667 4.00634L2 7.99967V13.333C2 13.6997 2.3 13.9997 2.66667 13.9997H3.33333C3.7 13.9997 4 13.6997 4 13.333V12.6663H12V13.333C12 13.6997 12.3 13.9997 12.6667 13.9997H13.3333C13.7 13.9997 14 13.6997 14 13.333V7.99967L12.6133 4.00634ZM4.33333 10.6663C3.78 10.6663 3.33333 10.2197 3.33333 9.66634C3.33333 9.11301 3.78 8.66634 4.33333 8.66634C4.88667 8.66634 5.33333 9.11301 5.33333 9.66634C5.33333 10.2197 4.88667 10.6663 4.33333 10.6663ZM11.6667 10.6663C11.1133 10.6663 10.6667 10.2197 10.6667 9.66634C10.6667 9.11301 11.1133 8.66634 11.6667 8.66634C12.22 8.66634 12.6667 9.11301 12.6667 9.66634C12.6667 10.2197 12.22 10.6663 11.6667 10.6663ZM3.33333 7.33301L4.33333 4.33301H11.6667L12.6667 7.33301H3.33333Z" fill="black" fill-opacity="0.54" />
	</svg>
)

export const DriverAddresIcon = () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M8.00016 1.33301C5.42016 1.33301 3.3335 3.41967 3.3335 5.99967C3.3335 9.49967 8.00016 14.6663 8.00016 14.6663C8.00016 14.6663 12.6668 9.49967 12.6668 5.99967C12.6668 3.41967 10.5802 1.33301 8.00016 1.33301ZM8.00016 7.66634C7.08016 7.66634 6.3335 6.91967 6.3335 5.99967C6.3335 5.07967 7.08016 4.33301 8.00016 4.33301C8.92016 4.33301 9.66683 5.07967 9.66683 5.99967C9.66683 6.91967 8.92016 7.66634 8.00016 7.66634Z" fill="black" fill-opacity="0.54" />
	</svg>
)

export const DriverCalendarIcon = () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M6 7.33301H4.66667V8.66634H6V7.33301ZM8.66667 7.33301H7.33333V8.66634H8.66667V7.33301ZM11.3333 7.33301H10V8.66634H11.3333V7.33301ZM12.6667 2.66634H12V1.33301H10.6667V2.66634H5.33333V1.33301H4V2.66634H3.33333C2.59333 2.66634 2.00667 3.26634 2.00667 3.99967L2 13.333C2 14.0663 2.59333 14.6663 3.33333 14.6663H12.6667C13.4 14.6663 14 14.0663 14 13.333V3.99967C14 3.26634 13.4 2.66634 12.6667 2.66634ZM12.6667 13.333H3.33333V5.99967H12.6667V13.333Z" fill="black" fill-opacity="0.54" />
	</svg>
)

export const DriverLoactionIcon = () => (
	<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M8.42855 5.33366C6.95521 5.33366 5.76188 6.52699 5.76188 8.00033C5.76188 9.47366 6.95521 10.667 8.42855 10.667C9.90188 10.667 11.0952 9.47366 11.0952 8.00033C11.0952 6.52699 9.90188 5.33366 8.42855 5.33366ZM14.3885 7.33366C14.0819 4.55366 11.8752 2.34699 9.09521 2.04033V0.666992H7.76188V2.04033C4.98188 2.34699 2.77521 4.55366 2.46855 7.33366H1.09521V8.66699H2.46855C2.77521 11.447 4.98188 13.6537 7.76188 13.9603V15.3337H9.09521V13.9603C11.8752 13.6537 14.0819 11.447 14.3885 8.66699H15.7619V7.33366H14.3885ZM8.42855 12.667C5.84855 12.667 3.76188 10.5803 3.76188 8.00033C3.76188 5.42033 5.84855 3.33366 8.42855 3.33366C11.0085 3.33366 13.0952 5.42033 13.0952 8.00033C13.0952 10.5803 11.0085 12.667 8.42855 12.667Z" fill="black" fill-opacity="0.54" />
	</svg>
)

export const DriverLastSeenIcon = () => (
	<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fillRule="evenodd" clipRule="evenodd" d="M1.47656 7.99967C1.47656 4.31967 4.45656 1.33301 8.13656 1.33301C11.8232 1.33301 14.8099 4.31967 14.8099 7.99967C14.8099 11.6797 11.8232 14.6663 8.13656 14.6663C4.45656 14.6663 1.47656 11.6797 1.47656 7.99967ZM2.8099 7.99967C2.8099 10.9463 5.19656 13.333 8.14323 13.333C11.0899 13.333 13.4766 10.9463 13.4766 7.99967C13.4766 5.05301 11.0899 2.66634 8.14323 2.66634C5.19656 2.66634 2.8099 5.05301 2.8099 7.99967ZM7.47656 4.66634H8.47656V8.16634L11.4766 9.94634L10.9766 10.7663L7.47656 8.66634V4.66634Z" fill="black" fill-opacity="0.54" />
	</svg>
)

export const PhoneIcon = () => (
	<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M5.27076 7.19333C6.23076 9.08 7.77742 10.62 9.66409 11.5867L11.1308 10.12C11.3108 9.94 11.5774 9.88 11.8108 9.96C12.5574 10.2067 13.3641 10.34 14.1908 10.34C14.5574 10.34 14.8574 10.64 14.8574 11.0067V13.3333C14.8574 13.7 14.5574 14 14.1908 14C7.93076 14 2.85742 8.92667 2.85742 2.66667C2.85742 2.3 3.15742 2 3.52409 2H5.85742C6.22409 2 6.52409 2.3 6.52409 2.66667C6.52409 3.5 6.65742 4.3 6.90409 5.04667C6.97742 5.28 6.92409 5.54 6.73742 5.72667L5.27076 7.19333Z" fill="black" fill-opacity="0.54" />
	</svg>
)

export const FlagIcon = () => (
	<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M10.1715 4.00033L9.90479 2.66699H3.90479V14.0003H5.23812V9.33366H8.97145L9.23812 10.667H13.9048V4.00033H10.1715Z" fill="black" fill-opacity="0.54" />
	</svg>
)

export const WalletIcon = () => (
	<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M14.2856 12V12.6667C14.2856 13.4 13.6856 14 12.9523 14H3.61898C2.87898 14 2.28564 13.4 2.28564 12.6667V3.33333C2.28564 2.6 2.87898 2 3.61898 2H12.9523C13.6856 2 14.2856 2.6 14.2856 3.33333V4H8.28564C7.54564 4 6.95231 4.6 6.95231 5.33333V10.6667C6.95231 11.4 7.54564 12 8.28564 12H14.2856ZM8.28564 10.6667H14.9523V5.33333H8.28564V10.6667ZM10.9523 9C10.399 9 9.95231 8.55333 9.95231 8C9.95231 7.44667 10.399 7 10.9523 7C11.5056 7 11.9523 7.44667 11.9523 8C11.9523 8.55333 11.5056 9 10.9523 9Z" fill="black" fill-opacity="0.54" />
	</svg>
)

export const MapIcon = () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M13.6667 2L13.56 2.02L10 3.4L6 2L2.24 3.26667C2.1 3.31333 2 3.43333 2 3.58667V13.6667C2 13.8533 2.14667 14 2.33333 14L2.44 13.98L6 12.6L10 14L13.76 12.7333C13.9 12.6867 14 12.5667 14 12.4133V2.33333C14 2.14667 13.8533 2 13.6667 2ZM10 12.6667L6 11.26V3.33333L10 4.74V12.6667Z" fill="black" fill-opacity="0.54" />
	</svg>
)

export const DriversIcon = () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M7.99333 1.33301C4.31333 1.33301 1.32666 4.31967 1.32666 7.99967C1.32666 11.6797 4.31333 14.6663 7.99333 14.6663C11.6733 14.6663 14.66 11.6797 14.66 7.99967C14.66 4.31967 11.6733 1.33301 7.99333 1.33301ZM10.4 5.55967C11.1133 5.55967 11.6867 6.13301 11.6867 6.84634C11.6867 7.55968 11.1133 8.13301 10.4 8.13301C9.68666 8.13301 9.11333 7.55968 9.11333 6.84634C9.10666 6.13301 9.68666 5.55967 10.4 5.55967ZM6.39999 4.50634C7.26666 4.50634 7.97333 5.21301 7.97333 6.07967C7.97333 6.94634 7.26666 7.65301 6.39999 7.65301C5.53333 7.65301 4.82666 6.94634 4.82666 6.07967C4.82666 5.20634 5.52666 4.50634 6.39999 4.50634ZM6.39999 10.593V13.093C4.79999 12.593 3.53333 11.3597 2.97333 9.78634C3.67333 9.03967 5.41999 8.65967 6.39999 8.65967C6.75333 8.65967 7.19999 8.71301 7.66666 8.80634C6.57333 9.38634 6.39999 10.153 6.39999 10.593ZM7.99333 13.333C7.81333 13.333 7.63999 13.3263 7.46666 13.3063V10.593C7.46666 9.64634 9.42666 9.17301 10.4 9.17301C11.1133 9.17301 12.3467 9.43301 12.96 9.93967C12.18 11.9197 10.2533 13.333 7.99333 13.333Z" fill="black" fill-opacity="0.54" />
	</svg>
)

export const ImageIcon = () => (
	<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M21.5 19V5C21.5 3.9 20.6 3 19.5 3H5.5C4.4 3 3.5 3.9 3.5 5V19C3.5 20.1 4.4 21 5.5 21H19.5C20.6 21 21.5 20.1 21.5 19ZM9 13.5L11.5 16.51L15 12L19.5 18H5.5L9 13.5Z" fill="black" fill-opacity="0.38" />
	</svg>
)

export const VerifiedDriverIcon = () => (
	<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M6 0.666992L0 3.33366V7.33366C0 11.0337 2.56 14.4937 6 15.3337C9.44 14.4937 12 11.0337 12 7.33366V3.33366L6 0.666992ZM4.66667 11.3337L2 8.66699L2.94 7.72699L4.66667 9.44699L9.06 5.05366L10 6.00033L4.66667 11.3337Z" fill="#4CAF50" />
	</svg>
)

export const GroupOfOrdersIcon = () => (
	<svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
		<mask id="path-1-inside-1_3356_57824" fill="white">
			<path fillRule="evenodd" clipRule="evenodd" d="M14.5355 24.3828C19.5594 23.0945 23.2727 18.5362 23.2727 13.1105C23.2727 6.68393 18.063 1.47415 11.6364 1.47415C5.20978 1.47415 0 6.68393 0 13.1105C0 18.5365 3.71377 23.0951 8.7381 24.3831L11.1224 26.7674C11.4065 27.0514 11.8669 27.0514 12.151 26.7674L14.5355 24.3828Z" />
		</mask>
		<path fillRule="evenodd" clipRule="evenodd" d="M14.5355 24.3828C19.5594 23.0945 23.2727 18.5362 23.2727 13.1105C23.2727 6.68393 18.063 1.47415 11.6364 1.47415C5.20978 1.47415 0 6.68393 0 13.1105C0 18.5365 3.71377 23.0951 8.7381 24.3831L11.1224 26.7674C11.4065 27.0514 11.8669 27.0514 12.151 26.7674L14.5355 24.3828Z" fill="#F0F1F9" />
		<path d="M14.5355 24.3828L14.2645 23.3261L13.9753 23.4003L13.7641 23.6114L14.5355 24.3828ZM8.7381 24.3831L9.50949 23.6117L9.29831 23.4005L9.009 23.3263L8.7381 24.3831ZM22.1818 13.1105C22.1818 18.026 18.8177 22.1585 14.2645 23.3261L14.8065 25.4396C20.3011 24.0305 24.3636 19.0463 24.3636 13.1105H22.1818ZM11.6364 2.56506C17.4605 2.56506 22.1818 7.28642 22.1818 13.1105H24.3636C24.3636 6.08144 18.6654 0.383243 11.6364 0.383243V2.56506ZM1.09091 13.1105C1.09091 7.28642 5.81227 2.56506 11.6364 2.56506V0.383243C4.60729 0.383243 -1.09091 6.08144 -1.09091 13.1105H1.09091ZM9.009 23.3263C4.45547 22.159 1.09091 18.0263 1.09091 13.1105H-1.09091C-1.09091 19.0467 2.97206 24.0311 8.46721 25.4398L9.009 23.3263ZM11.8938 25.996L9.50949 23.6117L7.96671 25.1545L10.351 27.5388L11.8938 25.996ZM11.3796 25.996C11.5216 25.854 11.7518 25.854 11.8938 25.996L10.351 27.5388C11.0611 28.2488 12.2123 28.2488 12.9223 27.5388L11.3796 25.996ZM13.7641 23.6114L11.3796 25.996L12.9223 27.5388L15.3069 25.1542L13.7641 23.6114Z" fill="#a75108" mask="url(#path-1-inside-1_3356_57824)" />
		<g clipPath="url(#clip0_3356_57824)">
			<path d="M13.818 18.565H9.09073C7.48408 18.565 6.18164 17.2626 6.18164 15.6559V10.565C6.18164 8.95839 7.48409 7.65594 9.09073 7.65594H14.1816C15.7883 7.65594 17.0907 8.95839 17.0907 10.565V13.6559" stroke="#a75108" strokeWidth="1.09091" strokeLinecap="round" />
			<path d="M9.4541 7.65594H13.8177V11.3547C13.8177 12.0026 13.0344 12.3271 12.5762 11.869L12.1502 11.4429C11.8662 11.1589 11.4057 11.1589 11.1217 11.4429L10.6956 11.869C10.2375 12.3271 9.4541 12.0026 9.4541 11.3547V7.65594Z" stroke="#a75108" strokeWidth="1.09091" strokeLinejoin="round" />
			<path d="M17.0908 16.1573L16.3856 15.4521C16.1726 15.239 15.8272 15.239 15.6142 15.4521L14.909 16.1573M15.9999 18.565V15.6118" stroke="#a75108" strokeWidth="0.727273" strokeLinecap="round" />
		</g>
		<rect x="14.5459" y="0.0195923" width="11.8182" height="11" rx="5.5" fill="#a75108" />
		<path d="M20.4731 8.09733C20.0807 8.09733 19.7309 8.02514 19.4237 7.88078C19.1183 7.73641 18.8758 7.53743 18.6963 7.28386C18.5167 7.03029 18.4233 6.7397 18.4159 6.41209H19.5819C19.5949 6.63235 19.6874 6.81096 19.8596 6.94792C20.0317 7.08489 20.2362 7.15337 20.4731 7.15337C20.6619 7.15337 20.8285 7.11173 20.9729 7.02844C21.1191 6.9433 21.2329 6.82576 21.3144 6.67584C21.3976 6.52407 21.4393 6.35008 21.4393 6.15389C21.4393 5.95399 21.3967 5.77816 21.3116 5.62638C21.2283 5.47461 21.1126 5.35615 20.9645 5.27101C20.8165 5.18587 20.6471 5.14238 20.4565 5.14052C20.2899 5.14052 20.1279 5.17477 19.9706 5.24325C19.8151 5.31173 19.6939 5.4052 19.6069 5.52366L18.538 5.33209L18.8073 2.33364H22.2833V3.31647H19.7985L19.6513 4.74073H19.6846C19.7846 4.60006 19.9354 4.48346 20.1372 4.39091C20.3389 4.29837 20.5647 4.25209 20.8146 4.25209C21.157 4.25209 21.4624 4.33261 21.7308 4.49364C21.9992 4.65466 22.2111 4.87585 22.3666 5.15718C22.5221 5.43667 22.5989 5.75872 22.597 6.12335C22.5989 6.50649 22.51 6.84705 22.3305 7.14504C22.1528 7.44119 21.9039 7.6744 21.5837 7.84468C21.2653 8.01311 20.8951 8.09733 20.4731 8.09733Z" fill="white" />
		<defs>
			<clipPath id="clip0_3356_57824">
				<rect width="13.0909" height="13.0909" fill="white" transform="translate(5.09082 6.56503)" />
			</clipPath>
		</defs>
	</svg>

)

export const StackedShipmentsIcon = () => (
	<div className="scale-50 w-[30px] -ml-2 mr-1 -my-4">
		<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="30" cy="30" r="30" fill="#3F51B5" fill-opacity="0.5" />
			<circle cx="30" cy="30" r="25" fill="#3F51B5" />
			<path d="M33.834 22.7812V24.0703L28.1504 37H25.6699L31.3438 24.6562H23.9805V22.7812H33.834Z" fill="white" />
		</svg>
	</div>
)

export const StackedDriversIcon = () => (
	<div className="scale-50 w-[30px] -ml-2 mr-1 -my-4">
		<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="30" cy="30" r="30" fill="#4CAF50" fill-opacity="0.5" />
			<circle cx="30" cy="30" r="25" fill="#4CAF50" />
			<path d="M25.5578 22.7324V37H23.2043V25.5254L19.718 26.707V24.7637L25.2746 22.7324H25.5578ZM37.7586 22.6934H38.0516V24.6172H37.8855C37.0457 24.6172 36.3198 24.7474 35.7078 25.0078C35.1023 25.2682 34.6043 25.6263 34.2137 26.082C33.823 26.5378 33.5301 27.0716 33.3348 27.6836C33.146 28.2891 33.0516 28.9336 33.0516 29.6172V31.8535C33.0516 32.4199 33.1134 32.9212 33.2371 33.3574C33.3608 33.7871 33.5333 34.1484 33.7547 34.4414C33.9826 34.7279 34.243 34.946 34.5359 35.0957C34.8289 35.2454 35.1447 35.3203 35.4832 35.3203C35.8348 35.3203 36.1538 35.2487 36.4402 35.1055C36.7267 34.9557 36.9708 34.7507 37.1727 34.4902C37.3745 34.2298 37.5275 33.9206 37.6316 33.5625C37.7358 33.2044 37.7879 32.8138 37.7879 32.3906C37.7879 31.987 37.7358 31.6094 37.6316 31.2578C37.534 30.8997 37.3875 30.5872 37.1922 30.3203C36.9969 30.0469 36.7527 29.8353 36.4598 29.6855C36.1733 29.5293 35.8413 29.4512 35.4637 29.4512C34.9949 29.4512 34.5685 29.5618 34.1844 29.7832C33.8068 30.0046 33.5008 30.2943 33.2664 30.6523C33.0385 31.0039 32.9148 31.3783 32.8953 31.7754L31.9969 31.4824C32.049 30.877 32.1824 30.3333 32.3973 29.8516C32.6186 29.3698 32.9083 28.9596 33.2664 28.6211C33.6245 28.2826 34.0379 28.0254 34.5066 27.8496C34.9819 27.6673 35.5027 27.5762 36.0691 27.5762C36.7592 27.5762 37.3582 27.7064 37.866 27.9668C38.3738 28.2272 38.7937 28.582 39.1258 29.0312C39.4643 29.474 39.715 29.9818 39.8777 30.5547C40.047 31.1211 40.1316 31.7135 40.1316 32.332C40.1316 33.0156 40.0275 33.6536 39.8191 34.2461C39.6108 34.832 39.3048 35.3464 38.9012 35.7891C38.504 36.2318 38.019 36.5768 37.4461 36.8242C36.8797 37.0716 36.2352 37.1953 35.5125 37.1953C34.7508 37.1953 34.0704 37.0488 33.4715 36.7559C32.879 36.4629 32.3745 36.0592 31.9578 35.5449C31.5477 35.0306 31.2352 34.4382 31.0203 33.7676C30.8055 33.097 30.698 32.3874 30.698 31.6387V30.6621C30.698 29.5814 30.8348 28.5625 31.1082 27.6055C31.3816 26.6419 31.8016 25.7923 32.368 25.0566C32.9409 24.321 33.6733 23.7448 34.5652 23.3281C35.4572 22.9049 36.5216 22.6934 37.7586 22.6934Z" fill="white" />
		</svg>
	</div>
)

export const OrderIcon = () => (
	<svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
		<mask id="path-1-inside-1_3356_57833" fill="white">
			<path fillRule="evenodd" clipRule="evenodd" d="M14.5355 23.1556C19.5594 21.8673 23.2727 17.3089 23.2727 11.8833C23.2727 5.45667 18.063 0.246887 11.6364 0.246887C5.20978 0.246887 0 5.45667 0 11.8833C0 17.3092 3.71377 21.8678 8.7381 23.1558L11.1224 25.5401C11.4065 25.8241 11.8669 25.8241 12.151 25.5401L14.5355 23.1556Z" />
		</mask>
		<path fillRule="evenodd" clipRule="evenodd" d="M14.5355 23.1556C19.5594 21.8673 23.2727 17.3089 23.2727 11.8833C23.2727 5.45667 18.063 0.246887 11.6364 0.246887C5.20978 0.246887 0 5.45667 0 11.8833C0 17.3092 3.71377 21.8678 8.7381 23.1558L11.1224 25.5401C11.4065 25.8241 11.8669 25.8241 12.151 25.5401L14.5355 23.1556Z" fill="#F0F1F9" />
		<path d="M14.5355 23.1556L14.2645 22.0989L13.9753 22.173L13.7641 22.3842L14.5355 23.1556ZM8.7381 23.1558L9.50949 22.3844L9.29831 22.1732L9.009 22.0991L8.7381 23.1558ZM22.1818 11.8833C22.1818 16.7988 18.8177 20.9313 14.2645 22.0989L14.8065 24.2123C20.3011 22.8033 24.3636 17.8191 24.3636 11.8833H22.1818ZM11.6364 1.3378C17.4605 1.3378 22.1818 6.05916 22.1818 11.8833H24.3636C24.3636 4.85417 18.6654 -0.844022 11.6364 -0.844022V1.3378ZM1.09091 11.8833C1.09091 6.05916 5.81227 1.3378 11.6364 1.3378V-0.844022C4.60729 -0.844022 -1.09091 4.85417 -1.09091 11.8833H1.09091ZM9.009 22.0991C4.45547 20.9318 1.09091 16.7991 1.09091 11.8833H-1.09091C-1.09091 17.8194 2.97206 22.8039 8.46721 24.2125L9.009 22.0991ZM11.8938 24.7687L9.50949 22.3844L7.96671 23.9272L10.351 26.3115L11.8938 24.7687ZM11.3796 24.7687C11.5216 24.6267 11.7518 24.6267 11.8938 24.7687L10.351 26.3115C11.0611 27.0216 12.2123 27.0216 12.9223 26.3115L11.3796 24.7687ZM13.7641 22.3842L11.3796 24.7687L12.9223 26.3115L15.3069 23.927L13.7641 22.3842Z" fill="#a75108" mask="url(#path-1-inside-1_3356_57833)" />
		<g clipPath="url(#clip0_3356_57833)">
			<path d="M13.818 17.3378H9.09073C7.48408 17.3378 6.18164 16.0354 6.18164 14.4287V9.3378C6.18164 7.73116 7.48409 6.42871 9.09073 6.42871H14.1816C15.7883 6.42871 17.0907 7.73116 17.0907 9.3378V12.4287" stroke="#a75108" strokeWidth="1.09091" strokeLinecap="round" />
			<path d="M9.4541 6.42871H13.8177V10.1275C13.8177 10.7754 13.0344 11.0999 12.5762 10.6417L12.1502 10.2157C11.8662 9.93168 11.4057 9.93168 11.1217 10.2157L10.6956 10.6417C10.2375 11.0999 9.4541 10.7754 9.4541 10.1275V6.42871Z" stroke="#a75108" strokeWidth="1.09091" strokeLinejoin="round" />
			<path d="M17.0908 14.93L16.3856 14.2248C16.1726 14.0118 15.8272 14.0118 15.6142 14.2248L14.909 14.93M15.9999 17.3378V14.3846" stroke="#a75108" strokeWidth="0.727273" strokeLinecap="round" />
		</g>
		<defs>
			<clipPath id="clip0_3356_57833">
				<rect width="13.0909" height="13.0909" fill="white" transform="translate(5.09082 5.3378)" />
			</clipPath>
		</defs>
	</svg>
)

export const OrderDropoffIcon = () => (
	<svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
		<mask id="path-1-inside-1_3356_57840" fill="white">
			<path fillRule="evenodd" clipRule="evenodd" d="M14.5355 23.1556C19.5594 21.8673 23.2727 17.3089 23.2727 11.8832C23.2727 5.45665 18.063 0.246872 11.6364 0.246872C5.20978 0.246872 0 5.45665 0 11.8832C0 17.3092 3.71377 21.8678 8.7381 23.1558L11.1224 25.5401C11.4065 25.8241 11.8669 25.8241 12.151 25.5401L14.5355 23.1556Z" />
		</mask>
		<path fillRule="evenodd" clipRule="evenodd" d="M14.5355 23.1556C19.5594 21.8673 23.2727 17.3089 23.2727 11.8832C23.2727 5.45665 18.063 0.246872 11.6364 0.246872C5.20978 0.246872 0 5.45665 0 11.8832C0 17.3092 3.71377 21.8678 8.7381 23.1558L11.1224 25.5401C11.4065 25.8241 11.8669 25.8241 12.151 25.5401L14.5355 23.1556Z" fill="#F9F8F0" />
		<path d="M14.5355 23.1556L14.2645 22.0988L13.9753 22.173L13.7641 22.3842L14.5355 23.1556ZM8.7381 23.1558L9.50949 22.3844L9.29831 22.1732L9.009 22.099L8.7381 23.1558ZM22.1818 11.8832C22.1818 16.7987 18.8177 20.9313 14.2645 22.0988L14.8065 24.2123C20.3011 22.8033 24.3636 17.819 24.3636 11.8832H22.1818ZM11.6364 1.33778C17.4605 1.33778 22.1818 6.05914 22.1818 11.8832H24.3636C24.3636 4.85416 18.6654 -0.844037 11.6364 -0.844037V1.33778ZM1.09091 11.8832C1.09091 6.05914 5.81227 1.33778 11.6364 1.33778V-0.844037C4.60729 -0.844037 -1.09091 4.85416 -1.09091 11.8832H1.09091ZM9.009 22.099C4.45547 20.9317 1.09091 16.799 1.09091 11.8832H-1.09091C-1.09091 17.8194 2.97206 22.8038 8.46721 24.2125L9.009 22.099ZM11.8938 24.7687L9.50949 22.3844L7.96671 23.9272L10.351 26.3115L11.8938 24.7687ZM11.3796 24.7687C11.5216 24.6267 11.7518 24.6267 11.8938 24.7687L10.351 26.3115C11.0611 27.0215 12.2123 27.0215 12.9223 26.3115L11.3796 24.7687ZM13.7641 22.3842L11.3796 24.7687L12.9223 26.3115L15.3069 23.9269L13.7641 22.3842Z" fill="#C77700" mask="url(#path-1-inside-1_3356_57840)" />
		<g clipPath="url(#clip0_3356_57840)">
			<path d="M13.2725 17.3378H9.09073C7.48408 17.3378 6.18164 16.0353 6.18164 14.4287V9.33779C6.18164 7.73114 7.48409 6.4287 9.09073 6.4287H14.1816C15.7883 6.4287 17.0907 7.73114 17.0907 9.33779V12.4287" stroke="#C77700" strokeWidth="1.09091" strokeLinecap="round" />
			<path d="M9.4541 6.4287H13.8177V10.1274C13.8177 10.7754 13.0344 11.0999 12.5762 10.6417L12.1502 10.2157C11.8662 9.93166 11.4057 9.93166 11.1217 10.2157L10.6956 10.6417C10.2375 11.0999 9.4541 10.7754 9.4541 10.1274V6.4287Z" stroke="#C77700" strokeWidth="1.09091" strokeLinejoin="round" />
			<path d="M17.0908 16.4728L16.3856 17.178C16.1726 17.391 15.8272 17.391 15.6142 17.178L14.909 16.4728M15.9999 14.0651V17.0183" stroke="#C77700" strokeWidth="0.727273" strokeLinecap="round" />
		</g>
		<defs>
			<clipPath id="clip0_3356_57840">
				<rect width="13.0909" height="13.0909" fill="white" transform="translate(5.09082 5.33778)" />
			</clipPath>
		</defs>
	</svg>
)

export const AvailableDriverIcon = () => (
	<svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
		<mask id="path-1-inside-1_3356_58114" fill="white">
			<path fillRule="evenodd" clipRule="evenodd" d="M13.3242 22.9759C17.9294 21.795 21.3333 17.6165 21.3333 12.6429C21.3333 6.7519 16.5577 1.97627 10.6667 1.97627C4.77563 1.97627 0 6.7519 0 12.6429C0 17.6168 3.4043 21.7955 8.00996 22.9761L10.1956 25.1617C10.4559 25.4221 10.878 25.4221 11.1384 25.1617L13.3242 22.9759Z" />
		</mask>
		<path fillRule="evenodd" clipRule="evenodd" d="M13.3242 22.9759C17.9294 21.795 21.3333 17.6165 21.3333 12.6429C21.3333 6.7519 16.5577 1.97627 10.6667 1.97627C4.77563 1.97627 0 6.7519 0 12.6429C0 17.6168 3.4043 21.7955 8.00996 22.9761L10.1956 25.1617C10.4559 25.4221 10.878 25.4221 11.1384 25.1617L13.3242 22.9759Z" fill="#EEFFF5" />
		<path d="M13.3242 22.9759L12.9516 21.5229L12.5539 21.6249L12.2635 21.9153L13.3242 22.9759ZM8.00996 22.9761L9.07062 21.9155L8.78023 21.6251L8.38243 21.5231L8.00996 22.9761ZM10.1956 25.1617L11.2562 24.1011V24.1011L10.1956 25.1617ZM19.8333 12.6429C19.8333 16.915 16.9095 20.508 12.9516 21.5229L13.6968 24.4289C18.9493 23.082 22.8333 18.3179 22.8333 12.6429H19.8333ZM10.6667 3.47627C15.7293 3.47627 19.8333 7.58033 19.8333 12.6429H22.8333C22.8333 5.92348 17.3861 0.476273 10.6667 0.476273V3.47627ZM1.5 12.6429C1.5 7.58033 5.60406 3.47627 10.6667 3.47627V0.476273C3.9472 0.476273 -1.5 5.92348 -1.5 12.6429H1.5ZM8.38243 21.5231C4.42414 20.5084 1.5 16.9153 1.5 12.6429H-1.5C-1.5 18.3183 2.38445 23.0825 7.63748 24.4291L8.38243 21.5231ZM11.2562 24.1011L9.07062 21.9155L6.9493 24.0368L9.1349 26.2224L11.2562 24.1011ZM10.0777 24.1011C10.4032 23.7756 10.9308 23.7756 11.2562 24.1011L9.1349 26.2224C9.98104 27.0685 11.3529 27.0685 12.199 26.2224L10.0777 24.1011ZM12.2635 21.9153L10.0777 24.1011L12.199 26.2224L14.3848 24.0366L12.2635 21.9153Z" fill="#4CAF50" mask="url(#path-1-inside-1_3356_58114)" />
		<ellipse cx="10.667" cy="15.3929" rx="3.5" ry="1.75" stroke="#4CAF50" strokeLinejoin="round" />
		<circle cx="10.667" cy="10.1429" r="2" stroke="#4CAF50" strokeLinejoin="round" />
		<rect x="13.333" y="0.642944" width="10.6667" height="10.6667" rx="5.33333" fill="#4CAF50" />
		<g clip-path="url(#clip0_3356_58114)">
			<path d="M18.916 6.64294C18.916 6.78102 18.8041 6.89294 18.666 6.89294C18.5279 6.89294 18.416 6.78102 18.416 6.64294C18.416 6.50487 18.5279 6.39294 18.666 6.39294C18.8041 6.39294 18.916 6.50487 18.916 6.64294Z" fill="white" />
			<path fillRule="evenodd" clipRule="evenodd" d="M17.6654 2.89294C17.0671 2.89294 16.582 3.37797 16.582 3.97628L16.582 7.97628C16.582 8.57459 17.0671 9.05961 17.6654 9.05961H19.6654C20.2637 9.05961 20.7487 8.57459 20.7487 7.97628V3.97628C20.7487 3.37797 20.2637 2.89294 19.6654 2.89294L17.6654 2.89294ZM16.082 3.97628C16.082 3.10183 16.7909 2.39294 17.6654 2.39294L19.6654 2.39294C20.5398 2.39294 21.2487 3.10183 21.2487 3.97628V7.97628C21.2487 8.85073 20.5398 9.55961 19.6654 9.55961H17.6654C16.7909 9.55961 16.082 8.85073 16.082 7.97628L16.082 3.97628ZM18.6654 4.89294C18.182 4.89294 17.7449 5.08855 17.4279 5.40551C17.3303 5.50314 17.172 5.50314 17.0744 5.40551C16.9767 5.30788 16.9767 5.14959 17.0744 5.05195C17.4813 4.64506 18.0441 4.39294 18.6654 4.39294C19.2866 4.39294 19.8495 4.64506 20.2564 5.05195C20.354 5.14959 20.354 5.30788 20.2564 5.40551C20.1587 5.50314 20.0004 5.50314 19.9028 5.40551C19.5858 5.08855 19.1487 4.89294 18.6654 4.89294ZM18.6654 5.89294C18.4582 5.89294 18.271 5.97662 18.135 6.11261C18.0374 6.21025 17.8791 6.21025 17.7815 6.11261C17.6839 6.01498 17.6839 5.85669 17.7815 5.75906C18.0074 5.53313 18.3203 5.39294 18.6654 5.39294C19.0105 5.39294 19.3233 5.53313 19.5492 5.75906C19.6469 5.85669 19.6469 6.01498 19.5492 6.11261C19.4516 6.21025 19.2933 6.21025 19.1957 6.11261C19.0597 5.97662 18.8725 5.89294 18.6654 5.89294ZM18.082 8.30961C18.082 8.17154 18.194 8.05961 18.332 8.05961H18.9987C19.1368 8.05961 19.2487 8.17154 19.2487 8.30961C19.2487 8.44768 19.1368 8.55961 18.9987 8.55961H18.332C18.194 8.55961 18.082 8.44768 18.082 8.30961Z" fill="white" />
		</g>
		<defs>
			<clipPath id="clip0_3356_58114">
				<rect width="8" height="8" fill="white" transform="translate(14.666 1.97627)" />
			</clipPath>
		</defs>
	</svg>
)

export const AvailableDriverIconModified = () => (
	<svg width="24" height="32" viewBox="0 0 50 60" fill="none" xmlns="http://www.w3.org/2000/svg">
		<defs>
			<clipPath id="circleClip">
				<circle cx="25" cy="23" r="17" fill="red" />
			</clipPath>
		</defs>
		<rect x="2.5" y="1" width="45" height="45" rx="12" ry="12" fill="#d9ffe9" stroke="#02ab4c" />
		<circle cx="25" cy="23" r="18.5" width="38" height="30" fill="#02ab4c" />
		<circle cx="25" cy="23" r="18" width="38" height="30" fill="#d9ffe9" />
		<circle cx="25" cy="23" r="17.7" width="38" height="30" fill="#02ab4c" />
		<ellipse cx="25" cy="28" rx="7.25" ry="3.625" stroke="white" fill="white" strokeWidth="1.5" strokeLinejoin="round" />
		<circle cx="25" cy="18" r="4" stroke="white" fill="white" strokeLinejoin="round" />
		<rect x="25" y="46" width="2" height="10" fill="black" />
		<circle cx="26" cy="55" r="5" fill="black" />
		<g transform="translate(17, -4)">
			<rect x="23" y="1.5" width="10" height="13" rx="3" fill="#02ab4c" />
			<path d="M28.375 9C28.375 9.20711 28.2071 9.375 28 9.375C27.7929 9.375 27.625 9.20711 27.625 9C27.625 8.79289 27.7929 8.625 28 8.625C28.2071 8.625 28.375 8.79289 28.375 9Z" fill="#d9ffe9" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M26.5 3.375C25.6025 3.375 24.875 4.10254 24.875 5V11C24.875 11.8975 25.6025 12.625 26.5 12.625H29.5C30.3975 12.625 31.125 11.8975 31.125 11V5C31.125 4.10254 30.3975 3.375 29.5 3.375H26.5ZM24.125 5C24.125 3.68832 25.1883 2.625 26.5 2.625H29.5C30.8117 2.625 31.875 3.68832 31.875 5V11C31.875 12.3117 30.8117 13.375 29.5 13.375H26.5C25.1883 13.375 24.125 12.3117 24.125 11V5ZM28 6.375C27.275 6.375 26.6193 6.6684 26.1438 7.14384C25.9974 7.29029 25.76 7.29029 25.6135 7.14384C25.4671 6.9974 25.4671 6.75996 25.6135 6.61351C26.2239 6.00317 27.0681 5.625 28 5.625C28.9319 5.625 29.7761 6.00317 30.3865 6.61351C30.5329 6.75996 30.5329 6.9974 30.3865 7.14384C30.24 7.29029 30.0026 7.29029 29.8562 7.14384C29.3807 6.6684 28.725 6.375 28 6.375ZM28 7.875C27.6892 7.875 27.4085 8.00051 27.2045 8.2045C27.0581 8.35095 26.8206 8.35095 26.6742 8.2045C26.5277 8.05806 26.5277 7.82062 26.6742 7.67418C27.0131 7.33528 27.4823 7.125 28 7.125C28.5177 7.125 28.9869 7.33528 29.3258 7.67418C29.4723 7.82062 29.4723 8.05806 29.3258 8.2045C29.1794 8.35095 28.9419 8.35095 28.7955 8.2045C28.5915 8.00051 28.3108 7.875 28 7.875ZM27.125 11.5C27.125 11.2929 27.2929 11.125 27.5 11.125H28.5C28.7071 11.125 28.875 11.2929 28.875 11.5C28.875 11.7071 28.7071 11.875 28.5 11.875H27.5C27.2929 11.875 27.125 11.7071 27.125 11.5Z"
				fill="#d9ffe9"
			/>
		</g>
	</svg>
)

export const BusyDriverIcon = () => (
	<svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
		<mask id="path-1-inside-1_3356_58142" fill="white">
			<path fillRule="evenodd" clipRule="evenodd" d="M13.3242 22.9759C17.9294 21.795 21.3333 17.6165 21.3333 12.6429C21.3333 6.7519 16.5577 1.97627 10.6667 1.97627C4.77563 1.97627 0 6.7519 0 12.6429C0 17.6168 3.4043 21.7955 8.00996 22.9761L10.1956 25.1617C10.4559 25.4221 10.878 25.4221 11.1384 25.1617L13.3242 22.9759Z" />
		</mask>
		<path fillRule="evenodd" clipRule="evenodd" d="M13.3242 22.9759C17.9294 21.795 21.3333 17.6165 21.3333 12.6429C21.3333 6.7519 16.5577 1.97627 10.6667 1.97627C4.77563 1.97627 0 6.7519 0 12.6429C0 17.6168 3.4043 21.7955 8.00996 22.9761L10.1956 25.1617C10.4559 25.4221 10.878 25.4221 11.1384 25.1617L13.3242 22.9759Z" fill="#FFE3E3" />
		<path d="M13.3242 22.9759L13.0758 22.0073L12.8106 22.0752L12.6171 22.2688L13.3242 22.9759ZM8.00996 22.9761L8.71706 22.269L8.52347 22.0754L8.25827 22.0074L8.00996 22.9761ZM10.1956 25.1617L10.9027 24.4546L10.1956 25.1617ZM20.3333 12.6429C20.3333 17.1488 17.2495 20.937 13.0758 22.0073L13.5726 23.9446C18.6094 22.653 22.3333 18.0841 22.3333 12.6429H20.3333ZM10.6667 2.97627C16.0054 2.97627 20.3333 7.30419 20.3333 12.6429H22.3333C22.3333 6.19962 17.11 0.976273 10.6667 0.976273V2.97627ZM1 12.6429C1 7.30419 5.32791 2.97627 10.6667 2.97627V0.976273C4.22334 0.976273 -1 6.19962 -1 12.6429H1ZM8.25827 22.0074C4.0842 20.9374 1 17.1491 1 12.6429H-1C-1 18.0844 2.7244 22.6535 7.76164 23.9448L8.25827 22.0074ZM10.9027 24.4546L8.71706 22.269L7.30285 23.6832L9.48846 25.8688L10.9027 24.4546ZM10.4313 24.4546C10.5614 24.3244 10.7725 24.3244 10.9027 24.4546L9.48846 25.8688C10.1393 26.5197 11.1946 26.5197 11.8455 25.8688L10.4313 24.4546ZM12.6171 22.2688L10.4313 24.4546L11.8455 25.8688L14.0313 23.683L12.6171 22.2688Z" fill="#F44336" mask="url(#path-1-inside-1_3356_58142)" />
		<ellipse cx="10.667" cy="15.3929" rx="3.5" ry="1.75" stroke="#F44336" strokeLinejoin="round" />
		<circle cx="10.667" cy="10.1429" r="2" stroke="#F44336" strokeLinejoin="round" />
		<rect x="13.333" y="0.642944" width="10.6667" height="10.6667" rx="5.33333" fill="#F44336" />
		<g clip-path="url(#clip0_3356_58142)">
			<path fillRule="evenodd" clipRule="evenodd" d="M18.6657 3.5596C17.331 3.5596 16.249 4.64158 16.249 5.97627C16.249 7.31096 17.331 8.39293 18.6657 8.39293C20.0004 8.39293 21.0824 7.31096 21.0824 5.97627C21.0824 4.64158 20.0004 3.5596 18.6657 3.5596ZM15.749 5.97627C15.749 4.36544 17.0549 3.0596 18.6657 3.0596C20.2765 3.0596 21.5824 4.36544 21.5824 5.97627C21.5824 7.5871 20.2765 8.89293 18.6657 8.89293C17.0549 8.89293 15.749 7.5871 15.749 5.97627Z" fill="white" />
			<path fillRule="evenodd" clipRule="evenodd" d="M18.666 5.22627C18.2518 5.22627 17.916 5.56206 17.916 5.97627C17.916 6.39049 18.2518 6.72627 18.666 6.72627C19.0802 6.72627 19.416 6.39049 19.416 5.97627C19.416 5.56206 19.0802 5.22627 18.666 5.22627ZM17.416 5.97627C17.416 5.28592 17.9757 4.72627 18.666 4.72627C19.3564 4.72627 19.916 5.28592 19.916 5.97627C19.916 6.66663 19.3564 7.22627 18.666 7.22627C17.9757 7.22627 17.416 6.66663 17.416 5.97627Z" fill="white" />
			<path fillRule="evenodd" clipRule="evenodd" d="M18.666 2.39294C18.8041 2.39294 18.916 2.50487 18.916 2.64294V3.30961C18.916 3.44768 18.8041 3.55961 18.666 3.55961C18.5279 3.55961 18.416 3.44768 18.416 3.30961V2.64294C18.416 2.50487 18.5279 2.39294 18.666 2.39294Z" fill="white" />
			<path fillRule="evenodd" clipRule="evenodd" d="M18.666 8.39294C18.8041 8.39294 18.916 8.50487 18.916 8.64294V9.30961C18.916 9.44768 18.8041 9.55961 18.666 9.55961C18.5279 9.55961 18.416 9.44768 18.416 9.30961V8.64294C18.416 8.50487 18.5279 8.39294 18.666 8.39294Z" fill="white" />
			<path fillRule="evenodd" clipRule="evenodd" d="M22.249 5.97627C22.249 6.11434 22.1371 6.22627 21.999 6.22627L21.3324 6.22627C21.1943 6.22627 21.0824 6.11434 21.0824 5.97627C21.0824 5.8382 21.1943 5.72627 21.3324 5.72627L21.999 5.72627C22.1371 5.72627 22.249 5.8382 22.249 5.97627Z" fill="white" />
			<path fillRule="evenodd" clipRule="evenodd" d="M16.249 5.97627C16.249 6.11434 16.1371 6.22627 15.999 6.22627L15.3324 6.22627C15.1943 6.22627 15.0824 6.11434 15.0824 5.97627C15.0824 5.8382 15.1943 5.72627 15.3324 5.72627L15.999 5.72627C16.1371 5.72627 16.249 5.8382 16.249 5.97627Z" fill="white" />
		</g>
		<defs>
			<clipPath id="clip0_3356_58142">
				<rect width="8" height="8" fill="white" transform="translate(14.666 1.97627)" />
			</clipPath>
		</defs>
	</svg>
)

export const BusyDriverIconModified = () => (
	<svg width="24" height="32" viewBox="0 0 50 60" fill="none" xmlns="http://www.w3.org/2000/svg">
		<defs>
			<clipPath id="circleClip">
				<circle cx="25" cy="23" r="17" fill="red" />
			</clipPath>
		</defs>
		<rect x="2.5" y="1" width="45" height="45" rx="12" ry="12" fill="#ffdee4" stroke="#ff002e" />
		<circle cx="25" cy="23" r="18.5" width="38" height="30" fill="#ff002e" />
		<circle cx="25" cy="23" r="18" width="38" height="30" fill="white" />
		<circle cx="25" cy="23" r="17.7" width="38" height="30" fill="#ff002e" />
		<ellipse cx="25" cy="28" rx="7.25" ry="3.625" stroke="white" fill="white" strokeWidth="1.5" strokeLinejoin="round" />
		<circle cx="25" cy="18" r="4" stroke="white" fill="white" strokeLinejoin="round" />

		<rect x="25" y="46" width="2" height="10" fill="black" />
		<circle cx="26" cy="55" r="5" fill="black" />
		<g transform="translate(16, -4)">
			<rect x="21.9" y="1.9" width="12" height="12" rx="50" fill="#ff002e" />
			<g clip-path="url(#clip0_3358_58075)">
				<path fillRule="evenodd" clipRule="evenodd" d="M28 4.375C25.998 4.375 24.375 5.99797 24.375 8C24.375 10.002 25.998 11.625 28 11.625C30.002 11.625 31.625 10.002 31.625 8C31.625 5.99797 30.002 4.375 28 4.375ZM23.625 8C23.625 5.58375 25.5838 3.625 28 3.625C30.4162 3.625 32.375 5.58375 32.375 8C32.375 10.4162 30.4162 12.375 28 12.375C25.5838 12.375 23.625 10.4162 23.625 8Z" fill="#ffdee4" />
				<path fillRule="evenodd" clipRule="evenodd" d="M28 6.875C27.3787 6.875 26.875 7.37868 26.875 8C26.875 8.62132 27.3787 9.125 28 9.125C28.6213 9.125 29.125 8.62132 29.125 8C29.125 7.37868 28.6213 6.875 28 6.875ZM26.125 8C26.125 6.96447 26.9645 6.125 28 6.125C29.0355 6.125 29.875 6.96447 29.875 8C29.875 9.03553 29.0355 9.875 28 9.875C26.9645 9.875 26.125 9.03553 26.125 8Z" fill="#ffdee4" />
				<path fillRule="evenodd" clipRule="evenodd" d="M28 2.625C28.2071 2.625 28.375 2.79289 28.375 3V4C28.375 4.20711 28.2071 4.375 28 4.375C27.7929 4.375 27.625 4.20711 27.625 4V3C27.625 2.79289 27.7929 2.625 28 2.625Z" fill="#ffdee4" />
				<path fillRule="evenodd" clipRule="evenodd" d="M28 11.625C28.2071 11.625 28.375 11.7929 28.375 12V13C28.375 13.2071 28.2071 13.375 28 13.375C27.7929 13.375 27.625 13.2071 27.625 13V12C27.625 11.7929 27.7929 11.625 28 11.625Z" fill="#ffdee4" />
				<path fillRule="evenodd" clipRule="evenodd" d="M33.375 8C33.375 8.20711 33.2071 8.375 33 8.375L32 8.375C31.7929 8.375 31.625 8.20711 31.625 8C31.625 7.79289 31.7929 7.625 32 7.625L33 7.625C33.2071 7.625 33.375 7.79289 33.375 8Z" fill="#ffdee4" />
				<path fillRule="evenodd" clipRule="evenodd" d="M24.375 8C24.375 8.20711 24.2071 8.375 24 8.375L23 8.375C22.7929 8.375 22.625 8.20711 22.625 8C22.625 7.79289 22.7929 7.625 23 7.625L24 7.625C24.2071 7.625 24.375 7.79289 24.375 8Z" fill="#ffdee4" />
			</g>
		</g>
	</svg>
)

export const OfflineDriverIcon = () => (
	<svg width="36" height="38" viewBox="0 0 36 38" fill="none" xmlns="http://www.w3.org/2000/svg">
		<mask id="path-1-inside-1_3356_58018" fill="white">
			<path fillRule="evenodd" clipRule="evenodd" d="M19.9857 33.4996C26.8938 31.7284 32 25.4605 32 18C32 9.16344 24.8366 2 16 2C7.16344 2 0 9.16344 0 18C0 25.4605 5.1061 31.7284 12.0142 33.4996L15.2929 36.7782C15.6834 37.1687 16.3165 37.1687 16.7071 36.7782L19.9857 33.4996Z" />
		</mask>
		<path fillRule="evenodd" clipRule="evenodd" d="M19.9857 33.4996C26.8938 31.7284 32 25.4605 32 18C32 9.16344 24.8366 2 16 2C7.16344 2 0 9.16344 0 18C0 25.4605 5.1061 31.7284 12.0142 33.4996L15.2929 36.7782C15.6834 37.1687 16.3165 37.1687 16.7071 36.7782L19.9857 33.4996Z" fill="white" />
		<path d="M19.9857 33.4996L19.6131 32.0466L19.2154 32.1486L18.925 32.439L19.9857 33.4996ZM12.0142 33.4996L13.0749 32.4389L12.7845 32.1486L12.3868 32.0466L12.0142 33.4996ZM15.2929 36.7782L16.3535 35.7176L16.3535 35.7175L15.2929 36.7782ZM16.7071 36.7782L15.6464 35.7175L15.6464 35.7176L16.7071 36.7782ZM30.5 18C30.5 24.759 25.874 30.4414 19.6131 32.0466L20.3582 34.9526C27.9137 33.0155 33.5 26.162 33.5 18H30.5ZM16 3.5C24.0081 3.5 30.5 9.99187 30.5 18H33.5C33.5 8.33502 25.665 0.5 16 0.5V3.5ZM1.5 18C1.5 9.99187 7.99187 3.5 16 3.5V0.5C6.33502 0.5 -1.5 8.33502 -1.5 18H1.5ZM12.3868 32.0466C6.12598 30.4413 1.5 24.759 1.5 18H-1.5C-1.5 26.162 4.08623 33.0154 11.6417 34.9526L12.3868 32.0466ZM16.3535 35.7175L13.0749 32.4389L10.9536 34.5602L14.2322 37.8389L16.3535 35.7175ZM15.6464 35.7176C15.8417 35.5223 16.1583 35.5223 16.3535 35.7176L14.2322 37.8389C15.2085 38.8152 16.7914 38.8152 17.7677 37.8389L15.6464 35.7176ZM18.925 32.439L15.6464 35.7175L17.7677 37.8389L21.0463 34.5603L18.925 32.439Z" fill="gray" mask="url(#path-1-inside-1_3356_58018)" />
		<ellipse cx="16" cy="22.125" rx="5.25" ry="2.625" stroke="gray" strokeWidth="1.5" strokeLinejoin="round" />
		<circle cx="16" cy="14.25" r="3" stroke="gray" strokeWidth="1.5" strokeLinejoin="round" />
		<rect x="20" width="16" height="16" rx="8" fill="gray" />
		<path d="M28.375 9C28.375 9.20711 28.2071 9.375 28 9.375C27.7929 9.375 27.625 9.20711 27.625 9C27.625 8.79289 27.7929 8.625 28 8.625C28.2071 8.625 28.375 8.79289 28.375 9Z" fill="white" />
		<path fillRule="evenodd" clipRule="evenodd" d="M26.5 3.375C25.6025 3.375 24.875 4.10254 24.875 5L24.875 11C24.875 11.8975 25.6025 12.625 26.5 12.625H29.5C30.3975 12.625 31.125 11.8975 31.125 11V5C31.125 4.10254 30.3975 3.375 29.5 3.375L26.5 3.375ZM24.125 5C24.125 3.68832 25.1883 2.625 26.5 2.625L29.5 2.625C30.8117 2.625 31.875 3.68832 31.875 5V11C31.875 12.3117 30.8117 13.375 29.5 13.375H26.5C25.1883 13.375 24.125 12.3117 24.125 11L24.125 5ZM28 6.375C27.275 6.375 26.6193 6.6684 26.1438 7.14384C25.9974 7.29029 25.76 7.29029 25.6135 7.14384C25.4671 6.9974 25.4671 6.75996 25.6135 6.61351C26.2239 6.00317 27.0681 5.625 28 5.625C28.9319 5.625 29.7761 6.00317 30.3865 6.61351C30.5329 6.75996 30.5329 6.9974 30.3865 7.14384C30.24 7.29029 30.0026 7.29029 29.8562 7.14384C29.3807 6.6684 28.725 6.375 28 6.375ZM28 7.875C27.6892 7.875 27.4085 8.00051 27.2045 8.2045C27.0581 8.35095 26.8206 8.35095 26.6742 8.2045C26.5277 8.05806 26.5277 7.82062 26.6742 7.67418C27.0131 7.33528 27.4823 7.125 28 7.125C28.5177 7.125 28.9869 7.33528 29.3258 7.67418C29.4723 7.82062 29.4723 8.05806 29.3258 8.2045C29.1794 8.35095 28.9419 8.35095 28.7955 8.2045C28.5915 8.00051 28.3108 7.875 28 7.875ZM27.125 11.5C27.125 11.2929 27.2929 11.125 27.5 11.125H28.5C28.7071 11.125 28.875 11.2929 28.875 11.5C28.875 11.7071 28.7071 11.875 28.5 11.875H27.5C27.2929 11.875 27.125 11.7071 27.125 11.5Z" fill="white" />
	</svg>
)

export const OfflineDriverIconModified = () => (
	<svg width="24" height="32" viewBox="0 0 50 60" fill="none" xmlns="http://www.w3.org/2000/svg">
		<defs>
			<clipPath id="circleClip">
				<circle cx="25" cy="23" r="17" fill="red" />
			</clipPath>
		</defs>
		<rect x="2.5" y="1" width="45" height="45" rx="12" ry="12" fill="lightgray" stroke="gray" />
		<circle cx="25" cy="23" r="18.5" width="38" height="30" fill="gray" />
		<circle cx="25" cy="23" r="18" width="38" height="30" fill="lightgray" />
		<circle cx="25" cy="23" r="17.7" width="38" height="30" fill="gray" />
		<ellipse cx="25" cy="28" rx="7.25" ry="3.625" stroke="white" fill="white" strokeWidth="1.5" strokeLinejoin="round" />
		<circle cx="25" cy="18" r="4" stroke="white" fill="white" strokeLinejoin="round" />
		<rect x="25" y="46" width="2" height="10" fill="black" />
		<circle cx="26" cy="55" r="5" fill="black" />
		<g transform="translate(17, -4)">
			<rect x="23" y="1.5" width="10" height="13" rx="3" fill="gray" />
			<path d="M28.375 9C28.375 9.20711 28.2071 9.375 28 9.375C27.7929 9.375 27.625 9.20711 27.625 9C27.625 8.79289 27.7929 8.625 28 8.625C28.2071 8.625 28.375 8.79289 28.375 9Z" fill="lightgray" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M26.5 3.375C25.6025 3.375 24.875 4.10254 24.875 5V11C24.875 11.8975 25.6025 12.625 26.5 12.625H29.5C30.3975 12.625 31.125 11.8975 31.125 11V5C31.125 4.10254 30.3975 3.375 29.5 3.375H26.5ZM24.125 5C24.125 3.68832 25.1883 2.625 26.5 2.625H29.5C30.8117 2.625 31.875 3.68832 31.875 5V11C31.875 12.3117 30.8117 13.375 29.5 13.375H26.5C25.1883 13.375 24.125 12.3117 24.125 11V5ZM28 6.375C27.275 6.375 26.6193 6.6684 26.1438 7.14384C25.9974 7.29029 25.76 7.29029 25.6135 7.14384C25.4671 6.9974 25.4671 6.75996 25.6135 6.61351C26.2239 6.00317 27.0681 5.625 28 5.625C28.9319 5.625 29.7761 6.00317 30.3865 6.61351C30.5329 6.75996 30.5329 6.9974 30.3865 7.14384C30.24 7.29029 30.0026 7.29029 29.8562 7.14384C29.3807 6.6684 28.725 6.375 28 6.375ZM28 7.875C27.6892 7.875 27.4085 8.00051 27.2045 8.2045C27.0581 8.35095 26.8206 8.35095 26.6742 8.2045C26.5277 8.05806 26.5277 7.82062 26.6742 7.67418C27.0131 7.33528 27.4823 7.125 28 7.125C28.5177 7.125 28.9869 7.33528 29.3258 7.67418C29.4723 7.82062 29.4723 8.05806 29.3258 8.2045C29.1794 8.35095 28.9419 8.35095 28.7955 8.2045C28.5915 8.00051 28.3108 7.875 28 7.875ZM27.125 11.5C27.125 11.2929 27.2929 11.125 27.5 11.125H28.5C28.7071 11.125 28.875 11.2929 28.875 11.5C28.875 11.7071 28.7071 11.875 28.5 11.875H27.5C27.2929 11.875 27.125 11.7071 27.125 11.5Z"
				fill="lightgray"
			/>
		</g>
	</svg>
)

export const InfoIcon = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V11H13V17ZM13 9H11V7H13V9Z" fill="#FF9800" />
	</svg>
)

export const ThemeShiftIcon = () => (
	<svg width="19" height="19" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 1H14v6h5V2.5A1.5 1.5 0 0017.5 1zM19 9h-5v10h3.5a1.5 1.5 0 001.5-1.5V9zM1 14h11v5H2.5A1.5 1.5 0 011 17.5V14zM2.5 1A1.5 1.5 0 001 2.5V12h11V1H2.5z" fill="#666" /></svg>
)

export const DocsIcon = () => (
	<svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M19 3L5 3C3.89543 3 3 3.89543 3 5L3 19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z" stroke="#666" fill="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M7 7L17 7" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M7 12L17 12" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M7 17L13 17" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
	</svg>)

export const InfoDuotoneIcon = () => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="gray"
		xmlns="http://www.w3.org/2000/svg">
		<path d="M8.95043 20.6471C6.17301 19.9956 4.00437 17.827 3.35287 15.0496C2.88237 13.0437 2.88237 10.9563 3.35287 8.95043C4.00437 6.17301 6.17301 4.00437 8.95043 3.35288C10.9563 2.88237 13.0437 2.88237 15.0496 3.35287C17.827 4.00437 19.9956 6.173 20.6471 8.95043C21.1176 10.9563 21.1176 13.0437 20.6471 15.0496C19.9956 17.827 17.827 19.9956 15.0496 20.6471C13.0437 21.1176 10.9563 21.1176 8.95043 20.6471Z" stroke="black" strokeWidth="1.5" />
		<path d="M8.95043 20.6471C10.9563 21.1176 13.0437 21.1176 15.0496 20.6471C17.827 19.9956 19.9956 17.827 20.6471 15.0496C21.1176 13.0437 21.1176 10.9563 20.6471 8.95043C19.9956 6.173 17.827 4.00437 15.0496 3.35288C13.0437 2.88237 10.9563 2.88237 8.95043 3.35288C6.173 4.00437 4.00437 6.17301 3.35287 8.95043" stroke="gray" strokeWidth="1.5" strokeLinecap="round" />
		<path d="M12 15.5V11.5" stroke="orange" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		<circle cx="12" cy="9" r="0.5" stroke="orange" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
)

export const CardGreenIcon = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z" fill="#4CAF50" />
	</svg>
)

export const CardRedIcon = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z" fill="#F44336" />
	</svg>
)